export const AMC_DOCTORS = [
  {
    i: "0001",
    n: "선우성",
    de: "가정의학과",
    s: ["건강검진 이상소견", "성인병관리"],
  },
  {
    i: "0002",
    n: "손기영",
    de: "가정의학과",
    s: ["생활습관병 관리", "성인병"],
  },
  { i: "0003", n: "이정아", de: "가정의학과", s: ["비만", "생활습관병관리"] },
  { i: "0004", n: "조유선", de: "가정의학과", s: ["비만", "생활습관병관리"] },
  {
    i: "0005",
    n: "박서영",
    de: "가정의학과",
    s: ["건강 관리", "암동반질환클리닉"],
  },
  {
    i: "0006",
    n: "성윤수",
    de: "가정의학과",
    s: ["건강 관리", "암동반질환클리닉"],
  },
  { i: "0007", n: "이현정", de: "가정의학과", s: ["건강 관리"] },
  { i: "0008", n: "김사라", de: "간담도췌외과", s: [] },
  {
    i: "0009",
    n: "김송철",
    de: "간담도췌외과",
    s: ["췌장", "담도 및 담낭질환 수술"],
  },
  { i: "0010", n: "김태아", de: "간담도췌외과", s: [] },
  { i: "0011", n: "김형은", de: "간담도췌외과", s: [] },
  { i: "0012", n: "민선영", de: "간담도췌외과", s: [] },
  { i: "0013", n: "박귀숙", de: "간담도췌외과", s: [] },
  { i: "0014", n: "박상욱", de: "간담도췌외과", s: [] },
  { i: "0015", n: "성민규", de: "간담도췌외과", s: ["담도", "담낭"] },
  {
    i: "0016",
    n: "송기병",
    de: "간담도췌외과",
    s: ["복강경 및 로봇수술", "췌장 담도질환"],
  },
  {
    i: "0017",
    n: "이미랑",
    de: "간담도췌외과",
    s: ["수술이 필요한 담도", "담낭"],
  },
  { i: "0018", n: "이승재", de: "간담도췌외과", s: ["담도", "췌장"] },
  { i: "0019", n: "이우형", de: "간담도췌외과", s: ["담도", "췌장"] },
  { i: "0020", n: "이재훈", de: "간담도췌외과", s: ["담도 및 췌장암", "간암"] },
  { i: "0021", n: "이홍은", de: "간담도췌외과", s: [] },
  {
    i: "0022",
    n: "전예원",
    de: "간담도췌외과",
    s: ["담도", "췌장의 악성 및 양성 종양"],
  },
  { i: "0023", n: "정민영", de: "간담도췌외과", s: [] },
  { i: "0024", n: "한송이", de: "간담도췌외과", s: [] },
  {
    i: "0025",
    n: "홍광표",
    de: "간담도췌외과",
    s: ["일차성 간암", "전이성 간암"],
  },
  {
    i: "0026",
    n: "황대욱",
    de: "간담도췌외과",
    s: ["췌장 및 담도질환", "십이지장암 수술"],
  },
  { i: "0027", n: "박주연", de: "간담도췌외과", s: [] },
  { i: "0028", n: "오준협", de: "간담도췌외과", s: [] },
  { i: "0029", n: "이정훈", de: "간담도췌외과", s: [] },
  {
    i: "0030",
    n: "전은성",
    de: "간담도췌외과",
    s: ["간 담도 담낭 및 췌장 질환"],
  },
  {
    i: "0031",
    n: "강우형",
    de: "간이식ㆍ간담도외과",
    s: ["간암", "복강경/로봇 담낭절제술"],
  },
  { i: "0032", n: "고효정", de: "간이식ㆍ간담도외과", s: [] },
  { i: "0033", n: "김기훈", de: "간이식ㆍ간담도외과", s: ["간암", "담도암"] },
  { i: "0034", n: "김상훈", de: "간이식ㆍ간담도외과", s: [] },
  { i: "0035", n: "김성민", de: "간이식ㆍ간담도외과", s: [] },
  { i: "0036", n: "김아미", de: "간이식ㆍ간담도외과", s: [] },
  { i: "0037", n: "김유미", de: "간이식ㆍ간담도외과", s: [] },
  {
    i: "0038",
    n: "김지훈",
    de: "간이식ㆍ간담도외과",
    s: ["간암", "간내 담도암 및 간질환 복강경간절제술"],
  },
  { i: "0039", n: "나병곤", de: "간이식ㆍ간담도외과", s: [] },
  { i: "0040", n: "문덕복", de: "간이식ㆍ간담도외과", s: ["간암", "간이식"] },
  { i: "0041", n: "박길춘", de: "간이식ㆍ간담도외과", s: ["간암", "담도암"] },
  { i: "0042", n: "박현석", de: "간이식ㆍ간담도외과", s: [] },
  {
    i: "0043",
    n: "송기원",
    de: "간이식ㆍ간담도외과",
    s: ["간암 및 간종양", "간이식"],
  },
  { i: "0044", n: "안철수", de: "간이식ㆍ간담도외과", s: ["간암", "담도암"] },
  {
    i: "0045",
    n: "윤영인",
    de: "간이식ㆍ간담도외과",
    s: ["간암", "간이식 수혜자·기증자 사전검사"],
  },
  { i: "0046", n: "이승규", de: "간이식ㆍ간담도외과", s: ["간이식 상담"] },
  { i: "0047", n: "임선혜", de: "간이식ㆍ간담도외과", s: [] },
  { i: "0048", n: "정동환", de: "간이식ㆍ간담도외과", s: ["간암", "담도암"] },
  { i: "0049", n: "정이지", de: "간이식ㆍ간담도외과", s: [] },
  { i: "0050", n: "정지혜", de: "간이식ㆍ간담도외과", s: [] },
  {
    i: "0051",
    n: "좌은경",
    de: "간이식ㆍ간담도외과",
    s: ["복강경담낭절제술", "로봇담낭절제술"],
  },
  { i: "0052", n: "하태용", de: "간이식ㆍ간담도외과", s: ["간암", "담도암"] },
  { i: "0053", n: "황신", de: "간이식ㆍ간담도외과", s: ["간암", "간이식"] },
  { i: "0054", n: "원대현", de: "간이식ㆍ간담도외과", s: [] },
  { i: "0055", n: "최민하", de: "간이식ㆍ간담도외과", s: [] },
  {
    i: "0056",
    n: "김민재",
    de: "감염내과",
    s: ["중추신경계감염", "두경부감염"],
  },
  {
    i: "0057",
    n: "김성한",
    de: "감염내과",
    s: ["폐외결핵", "면역저하환자감염"],
  },
  { i: "0058", n: "배성만", de: "감염내과", s: ["감염 질환", "항생제 관리"] },
  { i: "0059", n: "이상오", de: "감염내과", s: ["감염 질환", "폐외결핵"] },
  {
    i: "0060",
    n: "임소윤",
    de: "감염내과",
    s: ["항생제 적정 사용 관리", "면역저하자감염"],
  },
  { i: "0061", n: "장의진", de: "감염내과", s: ["감염 질환", "신종 감염병"] },
  { i: "0062", n: "정용필", de: "감염내과", s: ["감염 질환", "불명열"] },
  { i: "0063", n: "정지원", de: "감염내과", s: ["감염 질환", "감염관리"] },
  { i: "0064", n: "최상호", de: "감염내과", s: ["중환자감염", "HIV감염"] },
  { i: "0065", n: "이상민", de: "감염내과", s: [] },
  { i: "0066", n: "강지희", de: "건강의학과", s: ["복부영상의학"] },
  { i: "0067", n: "경윤수", de: "건강의학과", s: ["비뇨기 질환"] },
  {
    i: "0068",
    n: "고명수",
    de: "건강의학과",
    s: ["흉부영상의학/유방영상의학"],
  },
  { i: "0069", n: "고윤석", de: "건강의학과", s: ["중환자의학", "호흡기질환"] },
  { i: "0070", n: "구자은", de: "건강의학과", s: ["소화기 질환"] },
  { i: "0071", n: "김광운", de: "건강의학과", s: ["소화기 질환"] },
  { i: "0072", n: "김미정", de: "건강의학과", s: ["치과"] },
  { i: "0073", n: "김미정", de: "신경과", s: ["파킨슨병", "이상운동질환"] },
  {
    i: "0074",
    n: "김민재",
    de: "건강의학과",
    s: ["두경부영상의학", "뇌신경영상의학"],
  },
  {
    i: "0075",
    n: "김선미",
    de: "건강의학과",
    s: ["두경부영상의학", "뇌신경영상의학"],
  },
  { i: "0076", n: "김소라", de: "건강의학과", s: ["부인과질환"] },
  { i: "0077", n: "김영신", de: "건강의학과", s: ["부인과질환"] },
  {
    i: "0078",
    n: "김은아",
    de: "건강의학과",
    s: ["흉부영상의학/유방영상의학"],
  },
  { i: "0079", n: "김은희", de: "건강의학과", s: ["소화기질환"] },
  { i: "0080", n: "김재일", de: "건강의학과", s: ["소화기질환"] },
  {
    i: "0081",
    n: "김정순",
    de: "심장내과",
    s: ["심장병예방 및 심장재활 클리닉", "심장질환"],
  },
  { i: "0082", n: "김태협", de: "건강의학과", s: ["소화기질환"] },
  { i: "0083", n: "김홍규", de: "건강의학과", s: ["내분비질환", "대사증후군"] },
  {
    i: "0084",
    n: "남효정",
    de: "심장내과",
    s: ["심장병예방 및 심장재활 클리닉", "심장질환"],
  },
  {
    i: "0085",
    n: "노한나",
    de: "건강의학과",
    s: ["흉부영상의학/유방영상의학"],
  },
  { i: "0086", n: "도윤서", de: "건강의학과", s: ["소화기질환"] },
  {
    i: "0087",
    n: "민선양",
    de: "건강의학과",
    s: ["심장질환", "심장병예방 및 심장재활 클리닉"],
  },
  {
    i: "0088",
    n: "박선영",
    de: "건강의학과",
    s: ["흉부영상의학/유방영상의학"],
  },
  { i: "0089", n: "박성원", de: "건강의학과", s: ["복부영상의학"] },
  { i: "0090", n: "박수진", de: "건강의학과", s: ["복부영상의학"] },
  { i: "0091", n: "박현정", de: "건강의학과", s: ["감염질환"] },
  { i: "0092", n: "박혜원", de: "건강의학과", s: ["소화기질환"] },
  { i: "0093", n: "배서은", de: "건강의학과", s: ["소화기질환"] },
  { i: "0094", n: "배성진", de: "건강의학과", s: ["내분비질환", "대사증후군"] },
  { i: "0095", n: "배인영", de: "건강의학과", s: ["복부영상의학"] },
  { i: "0096", n: "변소영", de: "건강의학과", s: ["신경과 질환"] },
  { i: "0097", n: "신보미", de: "건강의학과", s: ["알레르기질환"] },
  {
    i: "0098",
    n: "신지은",
    de: "건강의학과",
    s: ["두경부영상의학", "뇌신경영상의학"],
  },
  { i: "0099", n: "심진숙", de: "건강의학과", s: ["치과"] },
  { i: "0100", n: "안명희", de: "건강의학과", s: ["스트레스", "우울증"] },
  {
    i: "0101",
    n: "안은주",
    de: "건강의학과",
    s: ["흉부영상의학/유방영상의학"],
  },
  { i: "0102", n: "윤인숙", de: "건강의학과", s: ["복부영상의학"] },
  { i: "0103", n: "이규진", de: "건강의학과", s: ["소화기질환"] },
  { i: "0104", n: "이민정", de: "건강의학과", s: ["내분비질환", "대사증후군"] },
  { i: "0105", n: "이승희", de: "건강의학과", s: ["가정의학", "유방클리닉"] },
  { i: "0106", n: "이신원", de: "건강의학과", s: ["소화기질환"] },
  { i: "0107", n: "이여진", de: "건강의학과", s: ["류마티스 질환"] },
  { i: "0108", n: "이종수", de: "건강의학과", s: ["소화기질환"] },
  { i: "0109", n: "이지영", de: "건강의학과", s: ["소화기질환", "신장질환"] },
  { i: "0110", n: "이효정", de: "건강의학과", s: ["소화기질환"] },
  { i: "0111", n: "장혜숙", de: "건강의학과", s: ["소화기질환"] },
  { i: "0112", n: "정영주", de: "건강의학과", s: ["호흡기질환"] },
  {
    i: "0113",
    n: "정원정",
    de: "건강의학과",
    s: ["두경부영상의학", "뇌신경영상의학"],
  },
  { i: "0114", n: "정은주", de: "건강의학과", s: ["소화기질환"] },
  { i: "0115", n: "조현선", de: "건강의학과", s: ["복부영상의학"] },
  { i: "0116", n: "차은영", de: "건강의학과", s: ["복부영상의학"] },
  { i: "0117", n: "최강혁", de: "건강의학과", s: ["소화기질환"] },
  { i: "0118", n: "최다우리", de: "건강의학과", s: ["소화기질환"] },
  { i: "0119", n: "최재원", de: "건강의학과", s: ["소화기질환"] },
  { i: "0120", n: "최지영", de: "건강의학과", s: ["소화기질환"] },
  { i: "0121", n: "황희복", de: "건강의학과", s: ["부인과질환"] },
  { i: "0122", n: "안강민", de: "치과", s: ["구강암", "미세재건수술"] },
  { i: "0123", n: "이부규", de: "치과", s: ["양악수술", "턱관절장애"] },
  { i: "0124", n: "이지호", de: "치과", s: ["구강암", "안면골절"] },
  { i: "0125", n: "전주홍", de: "치과", s: ["양악수술", "턱교정수술"] },
  { i: "0126", n: "김종관", de: "내과", s: [] },
  { i: "0127", n: "김현정", de: "내과", s: [] },
  { i: "0128", n: "나지선", de: "내과", s: [] },
  { i: "0129", n: "정지수", de: "내과", s: [] },
  { i: "0130", n: "황선영", de: "내과", s: [] },
  { i: "0131", n: "차승아", de: "내과", s: [] },
  { i: "0132", n: "고은희", de: "내분비내과", s: ["당뇨병", "비만"] },
  { i: "0133", n: "고정민", de: "내분비내과", s: ["골다공증", "부신질환"] },
  { i: "0134", n: "김민선", de: "내분비내과", s: ["뇌하수체 질환", "당뇨병"] },
  { i: "0135", n: "김범준", de: "내분비내과", s: ["골다공증", "부신질환"] },
  { i: "0136", n: "김원구", de: "내분비내과", s: ["갑상선질환", "갑상선암"] },
  { i: "0137", n: "김태용", de: "내분비내과", s: ["갑상선질환", "갑상선암"] },
  { i: "0138", n: "민세희", de: "내분비내과", s: ["당뇨병", "비만"] },
  { i: "0139", n: "박중열", de: "내분비내과", s: ["당뇨병"] },
  { i: "0140", n: "이승훈", de: "내분비내과", s: ["부신질환", "골다공증"] },
  { i: "0141", n: "이우제", de: "내분비내과", s: ["당뇨병", "비만"] },
  { i: "0142", n: "전민지", de: "내분비내과", s: ["갑상선 질환", "갑상선 암"] },
  {
    i: "0143",
    n: "정창희",
    de: "내분비내과",
    s: ["당뇨병", "인슐린펌프 및 연속혈당측정장치 사용"],
  },
  { i: "0144", n: "조윤경", de: "내분비내과", s: ["당뇨병", "비만"] },
  { i: "0145", n: "곽기훈", de: "내분비내과", s: ["내분비질환"] },
  { i: "0146", n: "김희성", de: "내분비내과", s: ["내분비질환"] },
  { i: "0147", n: "이다인", de: "내분비내과", s: ["내분비질환"] },
  { i: "0148", n: "장민경", de: "내분비내과", s: ["내분비질환"] },
  {
    i: "0149",
    n: "김병창",
    de: "내분비외과",
    s: ["내분비외과(갑상선", "부갑상선"],
  },
  {
    i: "0150",
    n: "김원웅",
    de: "내분비외과",
    s: [
      "갑상선암(절개",
      "로봇 갑상선절제술 및 측경부 림프절절제술(액와부 접근법))",
    ],
  },
  {
    i: "0151",
    n: "성태연",
    de: "내분비외과",
    s: ["내분비외과(갑상선", "부갑상선"],
  },
  {
    i: "0152",
    n: "이유미",
    de: "내분비외과",
    s: ["내분비외과(갑상선", "부갑상선"],
  },
  {
    i: "0153",
    n: "정기욱",
    de: "내분비외과",
    s: ["갑상선수술", "부갑상선수술"],
  },
  { i: "0154", n: "김수경", de: "내분비외과", s: [] },
  { i: "0155", n: "이영민", de: "내분비외과", s: [] },
  { i: "0156", n: "최기훈", de: "내분비외과", s: [] },
  { i: "0157", n: "이은주", de: "노년내과", s: ["만성 질환", "식욕부진"] },
  { i: "0158", n: "장건영", de: "노년내과", s: ["만성질환", "근감소증"] },
  {
    i: "0159",
    n: "백지연",
    de: "노년내과",
    s: ["노인 만성 질환", "다약제사용"],
  },
  { i: "0160", n: "김민현", de: "대장항문외과", s: ["대장암", "직장암"] },
  { i: "0161", n: "김영일", de: "대장항문외과", s: ["대장암", "직장암"] },
  { i: "0162", n: "김찬욱", de: "대장항문외과", s: ["대장암", "직장암"] },
  { i: "0163", n: "문근배", de: "대장항문외과", s: [] },
  { i: "0164", n: "박은정", de: "대장항문외과", s: ["대장암", "직장암"] },
  { i: "0165", n: "박인자", de: "대장항문외과", s: ["대장암", "직장암"] },
  { i: "0166", n: "오수영", de: "대장항문외과", s: ["대장암", "직장암"] },
  { i: "0167", n: "윤용식", de: "대장항문외과", s: ["대장암", "직장암"] },
  { i: "0168", n: "이종률", de: "대장항문외과", s: ["대장암", "직장암"] },
  { i: "0169", n: "이종원", de: "대장항문외과", s: [] },
  { i: "0170", n: "임석병", de: "대장항문외과", s: ["대장암", "직장암"] },
  { i: "0171", n: "장태영", de: "대장항문외과", s: [] },
  { i: "0172", n: "채원영", de: "대장항문외과", s: [] },
  { i: "0173", n: "최혜윤", de: "대장항문외과", s: [] },
  { i: "0174", n: "강재철", de: "대장항문외과", s: [] },
  { i: "0175", n: "서기석", de: "대장항문외과", s: [] },
  { i: "0176", n: "이충엽", de: "대장항문외과", s: [] },
  { i: "0177", n: "장진기", de: "대장항문외과", s: [] },
  {
    i: "0178",
    n: "김영은",
    de: "류마티스내과",
    s: ["류마티스 질환", "류마티스관절염"],
  },
  {
    i: "0179",
    n: "김용길",
    de: "류마티스내과",
    s: ["강직성척추염", "류마티스 질환"],
  },
  {
    i: "0180",
    n: "안수민",
    de: "류마티스내과",
    s: ["류마티스 질환", "류마티스관절염"],
  },
  {
    i: "0181",
    n: "오지선",
    de: "류마티스내과",
    s: ["류마티스 질환", "류마티스관절염"],
  },
  {
    i: "0182",
    n: "유빈",
    de: "류마티스내과",
    s: ["류마티스 질환", "류마티스관절염"],
  },
  {
    i: "0183",
    n: "이창근",
    de: "류마티스내과",
    s: ["류마티스 질환", "류마티스관절염"],
  },
  { i: "0184", n: "홍석찬", de: "류마티스내과", s: ["염증성 근염", "루푸스"] },
  {
    i: "0185",
    n: "고원욱",
    de: "마취통증의학과",
    s: ["정형외과마취", "부위마취"],
  },
  { i: "0186", n: "구승우", de: "마취통증의학과", s: ["이비인후과 마취"] },
  {
    i: "0187",
    n: "권현정",
    de: "마취통증의학과",
    s: ["풍선확장술", "복합부위통증"],
  },
  { i: "0188", n: "권혜미", de: "마취통증의학과", s: [] },
  { i: "0189", n: "김경선", de: "마취통증의학과", s: [] },
  { i: "0190", n: "김경미", de: "마취통증의학과", s: [] },
  { i: "0191", n: "김보림", de: "마취통증의학과", s: [] },
  { i: "0192", n: "김선기", de: "마취통증의학과", s: [] },
  {
    i: "0193",
    n: "김성훈",
    de: "마취통증의학과",
    s: ["로봇수술마취", "의료기기"],
  },
  { i: "0194", n: "김연주", de: "마취통증의학과", s: [] },
  {
    i: "0195",
    n: "김영국",
    de: "마취통증의학과",
    s: ["이식마취", "비뇨기과마취"],
  },
  { i: "0196", n: "김영선", de: "마취통증의학과", s: [] },
  { i: "0197", n: "김욱종", de: "마취통증의학과", s: ["심폐마취"] },
  { i: "0198", n: "김종욱", de: "마취통증의학과", s: ["뇌신경 마취"] },
  { i: "0199", n: "김지윤", de: "마취통증의학과", s: [] },
  {
    i: "0200",
    n: "김찬식",
    de: "마취통증의학과",
    s: ["풍선확장술", "복합부위통증"],
  },
  { i: "0201", n: "김하정", de: "마취통증의학과", s: ["정형외과 마취"] },
  {
    i: "0202",
    n: "김형태",
    de: "마취통증의학과",
    s: ["정형외과마취(부위마취)"],
  },
  { i: "0203", n: "김희영", de: "마취통증의학과", s: [] },
  { i: "0204", n: "남재식", de: "마취통증의학과", s: ["심폐마취"] },
  { i: "0205", n: "노규정", de: "마취통증의학과", s: ["외과마취", "마취약리"] },
  {
    i: "0206",
    n: "노영진",
    de: "마취통증의학과",
    s: ["정형외과 마취", "부위 마취"],
  },
  { i: "0207", n: "민세희", de: "마취통증의학과", s: [] },
  { i: "0208", n: "박세웅", de: "마취통증의학과", s: [] },
  { i: "0209", n: "박수정", de: "마취통증의학과", s: [] },
  { i: "0210", n: "박용석", de: "마취통증의학과", s: ["뇌신경마취"] },
  { i: "0211", n: "박용희", de: "마취통증의학과", s: [] },
  { i: "0212", n: "박종연", de: "마취통증의학과", s: ["산과마취"] },
  { i: "0213", n: "박준영", de: "마취통증의학과", s: ["통증", "노인마취"] },
  { i: "0214", n: "박지인", de: "마취통증의학과", s: [] },
  { i: "0215", n: "박희선", de: "마취통증의학과", s: [] },
  { i: "0216", n: "방지연", de: "마취통증의학과", s: ["일반마취", "마취약리"] },
  { i: "0217", n: "송명희", de: "마취통증의학과", s: ["소아진정"] },
  { i: "0218", n: "송인경", de: "마취통증의학과", s: ["소아마취", "심폐마취"] },
  { i: "0219", n: "송준걸", de: "마취통증의학과", s: ["장기이식마취"] },
  { i: "0220", n: "신원정", de: "마취통증의학과", s: [] },
  { i: "0221", n: "신진우", de: "마취통증의학과", s: ["통증클리닉"] },
  { i: "0222", n: "심지연", de: "마취통증의학과", s: ["심폐 마취"] },
  { i: "0223", n: "심지훈", de: "마취통증의학과", s: [] },
  { i: "0224", n: "양성미", de: "마취통증의학과", s: [] },
  { i: "0225", n: "오주연", de: "마취통증의학과", s: [] },
  {
    i: "0226",
    n: "유지현",
    de: "마취통증의학과",
    s: ["성형외과마취", "비뇨의학과마취"],
  },
  {
    i: "0227",
    n: "이상욱",
    de: "마취통증의학과",
    s: ["심폐마취", "로봇수술마취"],
  },
  { i: "0228", n: "이서희", de: "마취통증의학과", s: [] },
  {
    i: "0229",
    n: "장동민",
    de: "마취통증의학과",
    s: ["장기이식", "산부인과 마취"],
  },
  { i: "0230", n: "장화영", de: "마취통증의학과", s: [] },
  {
    i: "0231",
    n: "전인구",
    de: "마취통증의학과",
    s: ["간이식", "신장이식 마취"],
  },
  {
    i: "0232",
    n: "정경운",
    de: "마취통증의학과",
    s: ["심폐마취", "수술장 외 마취"],
  },
  { i: "0233", n: "정성문", de: "마취통증의학과", s: ["이식마취", "외과마취"] },
  { i: "0234", n: "조성인", de: "마취통증의학과", s: [] },
  { i: "0235", n: "조영은", de: "마취통증의학과", s: [] },
  { i: "0236", n: "주은영", de: "마취통증의학과", s: ["소아진정"] },
  { i: "0237", n: "진지현", de: "마취통증의학과", s: ["심폐마취"] },
  { i: "0238", n: "최대기", de: "마취통증의학과", s: ["심폐마취"] },
  {
    i: "0239",
    n: "최병문",
    de: "마취통증의학과",
    s: ["혈관외과마취", "계량약리"],
  },
  {
    i: "0240",
    n: "최성수",
    de: "마취통증의학과",
    s: ["풍선확장술", "복합부위통증"],
  },
  { i: "0241", n: "최우종", de: "마취통증의학과", s: ["산과마취 및 부위마취"] },
  { i: "0242", n: "최윤희", de: "마취통증의학과", s: [] },
  {
    i: "0243",
    n: "최인철",
    de: "마취통증의학과",
    s: ["소아진정치료", "심폐 마취"],
  },
  {
    i: "0244",
    n: "최재문",
    de: "마취통증의학과",
    s: ["소아마취", "치과전신마취"],
  },
  { i: "0245", n: "하승일", de: "마취통증의학과", s: ["뇌신경 마취"] },
  {
    i: "0246",
    n: "함경돈",
    de: "마취통증의학과",
    s: ["로봇수술마취", "심폐마취"],
  },
  { i: "0247", n: "허인영", de: "마취통증의학과", s: [] },
  {
    i: "0248",
    n: "황규삼",
    de: "마취통증의학과",
    s: ["장기이식", "일반외과 마취"],
  },
  { i: "0249", n: "강세진", de: "마취통증의학과", s: [] },
  { i: "0250", n: "박은정", de: "마취통증의학과", s: [] },
  { i: "0251", n: "이가윤", de: "마취통증의학과", s: [] },
  { i: "0252", n: "이창진", de: "마취통증의학과", s: [] },
  { i: "0253", n: "곽정원", de: "방사선종양학과", s: [] },
  { i: "0254", n: "김수산", de: "방사선종양학과", s: ["유방암", "폐암"] },
  { i: "0255", n: "김연주", de: "방사선종양학과", s: ["부인과암", "비뇨기암"] },
  { i: "0256", n: "김영석", de: "방사선종양학과", s: ["부인과암", "비뇨기암"] },
  { i: "0257", n: "김종훈", de: "방사선종양학과", s: ["식도암", "소화기암"] },
  { i: "0258", n: "박민재", de: "방사선종양학과", s: [] },
  { i: "0259", n: "박진홍", de: "방사선종양학과", s: ["소화기암", "대장암"] },
  { i: "0260", n: "송시열", de: "방사선종양학과", s: ["두경부암", "폐암"] },
  { i: "0261", n: "신영섭", de: "방사선종양학과", s: ["폐암", "두경부암"] },
  { i: "0262", n: "안승도", de: "방사선종양학과", s: ["유방암", "소아암"] },
  {
    i: "0263",
    n: "윤상민",
    de: "방사선종양학과",
    s: ["간암", "상부위장관종양"],
  },
  { i: "0264", n: "이상욱", de: "방사선종양학과", s: ["두경부암", "림프종"] },
  { i: "0265", n: "정진홍", de: "방사선종양학과", s: ["간암", "유방암"] },
  { i: "0266", n: "정치영", de: "방사선종양학과", s: [] },
  { i: "0267", n: "조병철", de: "방사선종양학과", s: [] },
  {
    i: "0268",
    n: "김하은",
    de: "방사선종양학과",
    s: ["고식적 방사선치료(소화기암/ 비뇨기/부인과암)"],
  },
  {
    i: "0269",
    n: "송영주",
    de: "방사선종양학과",
    s: ["고식적 방사선치료(폐/유방암/두경부암/육종/MUO)"],
  },
  { i: "0270", n: "고현정", de: "병리과", s: ["신장병리", "비뇨생식계병리"] },
  { i: "0271", n: "공경엽", de: "병리과", s: ["유방병리", "내분비병리"] },
  { i: "0272", n: "김덕훈", de: "병리과", s: [] },
  { i: "0273", n: "김종재", de: "병리과", s: ["소아병리"] },
  { i: "0274", n: "김지훈", de: "병리과", s: ["간ㆍ담도췌병리", "위장관병리"] },
  { i: "0275", n: "남수정", de: "병리과", s: [] },
  { i: "0276", n: "박양순", de: "병리과", s: [] },
  { i: "0277", n: "박영수", de: "병리과", s: ["위장관병리", "폐병리"] },
  { i: "0278", n: "박찬식", de: "병리과", s: ["피부병리", "림프망내계병리"] },
  { i: "0279", n: "성창옥", de: "병리과", s: [] },
  { i: "0280", n: "손우찬", de: "병리과", s: [] },
  { i: "0281", n: "송동은", de: "병리과", s: ["내분비 병리", "세포병리"] },
  { i: "0282", n: "송민정", de: "병리과", s: [] },
  { i: "0283", n: "송인혜", de: "병리과", s: [] },
  {
    i: "0284",
    n: "송준선",
    de: "병리과",
    s: ["골연부 병리", "두경부 병리. 폐병리"],
  },
  { i: "0285", n: "신진호", de: "병리과", s: [] },
  { i: "0286", n: "안보경", de: "암병원", s: [] },
  { i: "0287", n: "이희진", de: "병리과", s: [] },
  { i: "0288", n: "정병관", de: "암병원", s: [] },
  { i: "0289", n: "정지선", de: "병리과", s: [] },
  { i: "0290", n: "조영미", de: "병리과", s: ["신장병리", "비뇨생식계병리"] },
  { i: "0291", n: "조의리", de: "병리과", s: [] },
  { i: "0292", n: "조정현", de: "병리과", s: [] },
  { i: "0293", n: "조해연", de: "병리과", s: [] },
  { i: "0294", n: "천성민", de: "병리과", s: ["유전체병리"] },
  { i: "0295", n: "최진", de: "병리과", s: ["분자병리"] },
  { i: "0296", n: "황희상", de: "병리과", s: [] },
  { i: "0297", n: "홍승모", de: "병리과", s: ["소화기병리", "간ㆍ담췌병리"] },
  { i: "0298", n: "송하림", de: "병리과", s: [] },
  { i: "0299", n: "이소망", de: "병리과", s: [] },
  { i: "0300", n: "김정권", de: "비뇨의학과", s: ["신장암", "전립선암"] },
  { i: "0301", n: "박주현", de: "비뇨의학과", s: ["전립선비대증", "배뇨장애"] },
  { i: "0302", n: "박형근", de: "비뇨의학과", s: ["요로결석", "전립선비대증"] },
  { i: "0303", n: "서준교", de: "비뇨의학과", s: ["신장암", "전립선암"] },
  {
    i: "0304",
    n: "성종원",
    de: "비뇨의학과",
    s: ["비뇨기종양", "전립선비대증"],
  },
  { i: "0305", n: "송상훈", de: "비뇨의학과", s: ["수신증", "방광요관역류"] },
  { i: "0306", n: "송채린", de: "비뇨의학과", s: ["신장암", "신장암 의증"] },
  { i: "0307", n: "유달산", de: "비뇨의학과", s: ["전립선암", "신장암"] },
  { i: "0308", n: "이상민", de: "비뇨의학과", s: ["방광암", "전립선암"] },
  { i: "0309", n: "이정훈", de: "비뇨의학과", s: ["전립선비대증", "배뇨장애"] },
  { i: "0310", n: "임범진", de: "비뇨의학과", s: ["전립선암", "신장암"] },
  {
    i: "0311",
    n: "정인갑",
    de: "비뇨의학과",
    s: ["전립선센터(전립선암확진(로봇수술)", "전립선암의심)"],
  },
  { i: "0312", n: "홍범식", de: "비뇨의학과", s: ["방광암", "요관암"] },
  { i: "0313", n: "홍준혁", de: "비뇨의학과", s: ["전립선암"] },
  { i: "0314", n: "권용남", de: "비뇨의학과", s: [] },
  { i: "0315", n: "박민욱", de: "비뇨의학과", s: [] },
  { i: "0316", n: "신승한", de: "비뇨의학과", s: [] },
  { i: "0317", n: "이종필", de: "비뇨의학과", s: [] },
  {
    i: "0318",
    n: "강옥주",
    de: "산부인과",
    s: [
      "부인암 확진 및 의증 / 제자리암종 확진 및 의증 / 양성종양 및 질환 / 복강경 수술",
      "로봇 수술",
    ],
  },
  { i: "0319", n: "고지혜", de: "산부인과", s: ["고위험임신", "산과질환"] },
  {
    i: "0320",
    n: "김대연",
    de: "산부인과",
    s: ["부인암 확진 / 자궁 내막 제자리암종 확진 / 복강경 수술", "로봇 수술"],
  },
  {
    i: "0321",
    n: "김성훈",
    de: "산부인과",
    s: ["양성종양 및 질환\n/난임", "가임력보존\n/복강경수술"],
  },
  { i: "0322", n: "김종혁", de: "산부인과", s: ["부인암 확진"] },
  {
    i: "0323",
    n: "김주현",
    de: "산부인과",
    s: ["부인암 확진/제자리암종 확진/난소종양/복강경 수술", "로봇 수술"],
  },
  {
    i: "0324",
    n: "김주희",
    de: "산부인과",
    s: ["생식의학불임클리닉", "난임 및 가임력보존 클리닉"],
  },
  {
    i: "0325",
    n: "박정열",
    de: "산부인과",
    s: [
      "부인암 확진 및 의증 / 제자리암종 확진 및 의증 / 임신성 융모막 질환",
      "포상기태 / 부인암 가임력 보존치료/ 자궁근종",
    ],
  },
  { i: "0326", n: "박현정", de: "산부인과", s: [] },
  { i: "0327", n: "신예나", de: "산부인과", s: [] },
  {
    i: "0328",
    n: "원혜성",
    de: "산부인과",
    s: ["태아심장정밀진단", "태아치료"],
  },
  {
    i: "0329",
    n: "이미영",
    de: "산부인과",
    s: ["태아심장정밀진단", "태아정밀진단"],
  },
  {
    i: "0330",
    n: "이사라",
    de: "산부인과",
    s: [
      "양성종양 및 질환/\n다낭성난소증후군/\n미성년&미혼여성클리닉/\n골반장기탈출증클리닉/\n복강경수술",
      "로봇 수술",
    ],
  },
  {
    i: "0331",
    n: "이신화",
    de: "산부인과",
    s: ["부인암 확진/\n제자리암종 확진\n/복강경 수술", "로봇 수술"],
  },
  { i: "0332", n: "이유진", de: "산부인과", s: ["산과질환"] },
  { i: "0333", n: "정진훈", de: "산부인과", s: ["고위험임신", "다태임신"] },
  {
    i: "0334",
    n: "조현웅",
    de: "산부인과",
    s: ["부인암 확진 및 의증(난소암", "자궁경부암"],
  },
  { i: "0335", n: "채희동", de: "산부인과", s: ["여성불임", "골반장기탈출증"] },
  {
    i: "0336",
    n: "최민철",
    de: "산부인과",
    s: [
      "부인암 확진 및 의증 /제자리암종 확진 / 자궁근종",
      "난소종양/복강경 수술",
    ],
  },
  { i: "0337", n: "김예솔", de: "산부인과", s: ["부인과질환"] },
  { i: "0338", n: "박용희", de: "산부인과", s: ["부인과질환"] },
  { i: "0339", n: "권진근", de: "성형외과", s: ["하지재건", "상지재건"] },
  { i: "0340", n: "김영철", de: "성형외과", s: ["안면마비", "구개열"] },
  {
    i: "0341",
    n: "김은기",
    de: "성형외과",
    s: ["복벽 및 흉벽재건", "복직근 이개"],
  },
  {
    i: "0342",
    n: "김형배",
    de: "성형외과",
    s: ["미용성형클리닉(눈성형", "유방성형"],
  },
  { i: "0343", n: "박창식", de: "성형외과", s: ["미용성형클리닉", "재건"] },
  { i: "0344", n: "서현석", de: "성형외과", s: ["하지재건", "낫지않는 상처"] },
  {
    i: "0345",
    n: "엄진섭",
    de: "성형외과",
    s: ["미용성형클리닉(유방성형", "체형성형)"],
  },
  { i: "0346", n: "오태석", de: "성형외과", s: ["구순열", "구개열"] },
  { i: "0347", n: "정우식", de: "성형외과", s: ["두경부재건", "귀성형"] },
  {
    i: "0348",
    n: "최종우",
    de: "성형외과",
    s: ["양악수술", "수면무호흡 - 양악수술"],
  },
  {
    i: "0349",
    n: "한현호",
    de: "성형외과",
    s: ["미용성형클리닉(눈성형", "유방성형"],
  },
  { i: "0350", n: "홍준표", de: "성형외과", s: ["림프부종", "하지재건"] },
  {
    i: "0351",
    n: "김성진",
    de: "성형외과",
    s: ["성형외과 질환", "레이저미용/성형"],
  },
  {
    i: "0352",
    n: "사공용",
    de: "성형외과",
    s: ["성형외과 질환", "레이저미용/성형"],
  },
  { i: "0353", n: "김강모", de: "소화기내과", s: ["간질환", "간암"] },
  { i: "0354", n: "김경조", de: "소화기내과", s: ["대장질환"] },
  {
    i: "0355",
    n: "김도훈",
    de: "소화기내과",
    s: ["위·식도·십이지장질환", "치료내시경"],
  },
  {
    i: "0356",
    n: "김민규",
    de: "소화기내과",
    s: ["염증성 장질환", "대장·소장질환"],
  },
  { i: "0357", n: "김예진", de: "소화기내과", s: ["위·식도·십이지장질환"] },
  {
    i: "0358",
    n: "나희경",
    de: "소화기내과",
    s: ["위·식도·십이지장질환", "치료내시경"],
  },
  {
    i: "0359",
    n: "노진희",
    de: "소화기내과",
    s: ["위·식도·십이지장질환", "치료내시경"],
  },
  {
    i: "0360",
    n: "명승재",
    de: "소화기내과",
    s: ["대장·소장 질환(변비", "과민성장증후군)"],
  },
  {
    i: "0361",
    n: "박도현",
    de: "소화기내과",
    s: ["담도·췌장 질환", "십이지장 질환"],
  },
  { i: "0362", n: "박상형", de: "소화기내과", s: ["염증성 장질환"] },
  { i: "0363", n: "변소영", de: "소화기내과", s: ["위·식도·십이지장질환"] },
  {
    i: "0364",
    n: "변정식",
    de: "소화기내과",
    s: ["대장질환(대장암)", "치료 대장내시경(대장진행용종 및 조기대장암)"],
  },
  {
    i: "0365",
    n: "서동완",
    de: "소화기내과",
    s: ["담도·췌장센터", "담도·췌장암 클리닉"],
  },
  {
    i: "0366",
    n: "송태준",
    de: "소화기내과",
    s: ["담도·췌장질환", "담도췌장센터 초진클리닉( 췌담도암)"],
  },
  {
    i: "0367",
    n: "송호준",
    de: "소화기내과",
    s: ["위·식도·십이지장질환", "치료내시경"],
  },
  { i: "0368", n: "심주현", de: "소화기내과", s: ["간암"] },
  {
    i: "0369",
    n: "안지용",
    de: "소화기내과",
    s: ["위·식도·십이지장질환", "치료내시경"],
  },
  {
    i: "0370",
    n: "양동훈",
    de: "소화기내과",
    s: ["조기 대장암/유암종 내시경치료", "대장암"],
  },
  { i: "0371", n: "양지원", de: "소화기내과", s: ["간질환"] },
  {
    i: "0372",
    n: "예병덕",
    de: "소화기내과",
    s: ["염증성장질환(궤양성 대장염", "크론병"],
  },
  {
    i: "0373",
    n: "오동욱",
    de: "소화기내과",
    s: ["담도·췌장질환", "담도췌장센터 신환클리닉( 췌담도암)"],
  },
  { i: "0374", n: "이단비", de: "소화기내과", s: ["간질환"] },
  { i: "0375", n: "이선표", de: "소화기내과", s: ["장질환(대장", "소장)"] },
  { i: "0376", n: "이윤찬", de: "소화기내과", s: ["담도", "췌장질환"] },
  { i: "0377", n: "이정환", de: "소화기내과", s: ["담도", "췌장질환"] },
  {
    i: "0378",
    n: "이정훈",
    de: "소화기내과",
    s: ["위·식도·십이지장질환", "치료내시경"],
  },
  {
    i: "0379",
    n: "이진혁",
    de: "소화기내과",
    s: ["위장관질환(위·식도·십이지장질환)"],
  },
  { i: "0380", n: "이한주", de: "소화기내과", s: ["간질환"] },
  {
    i: "0381",
    n: "임영석",
    de: "소화기내과",
    s: ["만성 B형간염", "만성 C형간염"],
  },
  { i: "0382", n: "전영훈", de: "소화기내과", s: ["담도", "췌장질환"] },
  {
    i: "0383",
    n: "정기욱",
    de: "소화기내과",
    s: ["식도운동질환(위식도역류", "아칼라시아"],
  },
  { i: "0384", n: "정성원", de: "소화기내과", s: ["간질환"] },
  {
    i: "0385",
    n: "정훈용",
    de: "소화기내과",
    s: ["위·식도·십이지장질환", "치료내시경"],
  },
  { i: "0386", n: "조성현", de: "소화기내과", s: ["담도", "췌장질환"] },
  {
    i: "0387",
    n: "최기돈",
    de: "소화기내과",
    s: ["위·식도·십이지장질환", "치료내시경"],
  },
  { i: "0388", n: "최원묵", de: "소화기내과", s: ["간암", "지방간염 클리닉"] },
  { i: "0389", n: "최종기", de: "소화기내과", s: ["간질환"] },
  { i: "0390", n: "한지수", de: "소화기내과", s: ["소화기내과 질환"] },
  {
    i: "0391",
    n: "황성욱",
    de: "소화기내과",
    s: ["염증성 장질환 (크론병", "궤양성 대장염"],
  },
  { i: "0392", n: "허건", de: "소화기내과", s: ["담도", "췌장질환"] },
  {
    i: "0393",
    n: "홍승욱",
    de: "소화기내과",
    s: ["대장 용종 클리닉", "대장 용종"],
  },
  { i: "0394", n: "구두엽", de: "소화기내과", s: [] },
  { i: "0395", n: "고주연", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0396", n: "김형진", de: "소화기내과", s: ["장질환(대장", "소장)"] },
  { i: "0397", n: "남효진", de: "소화기내과", s: ["간질환"] },
  { i: "0398", n: "박경호", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0399", n: "박중휘", de: "소화기내과", s: ["담도", "췌장질환"] },
  { i: "0400", n: "배경덕", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0401", n: "엄민영", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0402", n: "오수진", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0403", n: "오지윤", de: "소화기내과", s: ["장질환(대장", "소장)"] },
  { i: "0404", n: "유동만", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0405", n: "윤희백", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0406", n: "이여진", de: "소화기내과", s: ["장질환(대장", "소장)"] },
  { i: "0407", n: "이주연", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0408", n: "장유진", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0409", n: "조민주", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0410", n: "조홍신", de: "소화기내과", s: ["장질환(대장", "소장)"] },
  { i: "0411", n: "진태양", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0412", n: "하도윤", de: "소화기내과", s: [] },
  { i: "0413", n: "한민수", de: "소화기내과", s: ["소화기내과질환"] },
  { i: "0414", n: "홍주언", de: "소화기내과", s: ["장질환(대장", "소장)"] },
  {
    i: "0415",
    n: "김경모",
    de: "소아소화기영양과",
    s: ["소아 위장관 질환", "간염"],
  },
  {
    i: "0416",
    n: "김재광",
    de: "수부외과",
    s: ["수부질환 및 골절", "상완신경총 손상"],
  },
  {
    i: "0417",
    n: "신영호",
    de: "수부외과",
    s: ["수부 및 손목관절 질환", "외상"],
  },
  {
    i: "0418",
    n: "고영민",
    de: "신ㆍ췌장이식외과",
    s: ["신장이식", "췌장이식"],
  },
  {
    i: "0419",
    n: "권현욱",
    de: "신ㆍ췌장이식외과",
    s: ["신장이식", "췌장이식"],
  },
  {
    i: "0420",
    n: "권혜은",
    de: "신ㆍ췌장이식외과",
    s: ["신장이식", "췌장이식"],
  },
  {
    i: "0421",
    n: "김영훈",
    de: "신ㆍ췌장이식외과",
    s: ["신장이식", "췌장이식"],
  },
  {
    i: "0422",
    n: "김진명",
    de: "신ㆍ췌장이식외과",
    s: ["신장이식", "췌장이식"],
  },
  {
    i: "0423",
    n: "박성해",
    de: "신ㆍ췌장이식외과",
    s: ["신장이식", "췌장이식"],
  },
  { i: "0424", n: "신성", de: "신ㆍ췌장이식외과", s: ["신장이식", "췌장이식"] },
  { i: "0425", n: "임소향", de: "신ㆍ췌장이식외과", s: [] },
  { i: "0426", n: "이승민", de: "신ㆍ췌장이식외과", s: [] },
  { i: "0427", n: "강동화", de: "신경과", s: ["뇌졸중"] },
  { i: "0428", n: "구용서", de: "신경과", s: ["뇌전증수술", "뇌전증"] },
  { i: "0429", n: "권순억", de: "신경과", s: ["뇌졸중", "뇌혈관 협착 클리닉"] },
  {
    i: "0430",
    n: "김범준",
    de: "신경과",
    s: ["뇌졸중", "급성기 뇌졸중 클리닉"],
  },
  { i: "0431", n: "김보영", de: "신경과", s: ["뇌전증", "두통"] },
  {
    i: "0432",
    n: "김지연",
    de: "신경과",
    s: ["말초신경근육질환", "신경면역질환"],
  },
  { i: "0433", n: "김현진", de: "신경과", s: ["신경면역질환", "탈수초질환"] },
  { i: "0434", n: "김효재", de: "신경과", s: ["경련성질환", "뇌전증"] },
  { i: "0435", n: "박진", de: "신경과", s: [] },
  {
    i: "0436",
    n: "배재한",
    de: "신경과",
    s: ["뇌졸중", "급성기 뇌졸중 클리닉"],
  },
  { i: "0437", n: "송정윤", de: "신경과", s: ["뇌졸중", "뇌혈관협착"] },
  { i: "0438", n: "오현선", de: "신경과", s: ["뇌졸중", "뇌혈관협착"] },
  { i: "0439", n: "양욱진", de: "신경과", s: ["뇌졸중", "뇌혈관질환"] },
  { i: "0440", n: "이은재", de: "신경과", s: ["신경면역질환", "시신경척수염"] },
  { i: "0441", n: "이재홍", de: "신경과", s: ["기억력장애", "알츠하이머병"] },
  { i: "0442", n: "이혜정", de: "신경과", s: [] },
  { i: "0443", n: "임영민", de: "신경과", s: ["신경면역", "말초신경근육질환"] },
  { i: "0444", n: "임재성", de: "신경과", s: ["기억력장애", "알츠하이머병"] },
  { i: "0445", n: "장준영", de: "신경과", s: ["뇌졸중", "중환자 치료"] },
  { i: "0446", n: "장현정", de: "신경과", s: [] },
  { i: "0447", n: "장혜민", de: "신경과", s: ["기억력장애", "알츠하이머병"] },
  {
    i: "0448",
    n: "전상범",
    de: "신경과",
    s: ["응급 중증 신경계 질환", "중환자치료"],
  },
  { i: "0449", n: "정선주", de: "신경과", s: ["파킨슨병", "이상운동질환"] },
  { i: "0450", n: "조성양", de: "신경과", s: ["파킨슨병", "이상운동질환"] },
  {
    i: "0451",
    n: "진주예",
    de: "신경과",
    s: ["말초신경근육질환", "신경면역질환"],
  },
  { i: "0452", n: "황병욱", de: "신경과", s: [] },
  { i: "0453", n: "김정훈", de: "신경과", s: ["뇌전증", "경련성질환"] },
  { i: "0454", n: "이성은", de: "신경과", s: ["기억력장애", "알츠하이머병"] },
  { i: "0455", n: "이유진", de: "신경과", s: ["파킨슨병", "이상운동질환"] },
  { i: "0456", n: "최문관", de: "신경과", s: ["파킨슨병", "이상운동질환"] },
  { i: "0457", n: "권미선", de: "신경과", s: ["신경 말-언어-삼킴장애"] },
  { i: "0458", n: "권병덕", de: "신경외과", s: ["뇌동맥류", "뇌혈관기형"] },
  { i: "0459", n: "김모이네", de: "신경외과", s: ["뇌신경중환자", "두부외상"] },
  { i: "0460", n: "김승빈", de: "신경외과", s: [] },
  { i: "0461", n: "김영훈", de: "신경외과", s: ["뇌하수체종양", "뇌종양"] },
  { i: "0462", n: "김정훈", de: "신경외과", s: ["뇌종양"] },
  {
    i: "0463",
    n: "김준형",
    de: "신경외과",
    s: ["정위로봇수술(뇌종양", "뇌전증)"],
  },
  { i: "0464", n: "박중철", de: "신경외과", s: ["뇌동맥류", "뇌혈관기형"] },
  { i: "0465", n: "박진훈", de: "신경외과", s: ["척추질환(경추", "흉추"] },
  { i: "0466", n: "변유경", de: "신경외과", s: ["뇌종양", "수두증"] },
  { i: "0467", n: "송상우", de: "신경외과", s: ["교모세포종", "신경교종"] },
  {
    i: "0468",
    n: "신홍경",
    de: "신경외과",
    s: ["최소침습척추수술", "척추내시경수술"],
  },
  { i: "0469", n: "안재성", de: "신경외과", s: ["성인모야모야", "뇌동맥류"] },
  {
    i: "0470",
    n: "이승주",
    de: "신경외과",
    s: ["뇌신경중환자", "외상후 뇌출혈"],
  },
  {
    i: "0471",
    n: "전상용",
    de: "신경외과",
    s: ["손떨림 수전증 초음파뇌수술 클리닉", "척추질환(경추"],
  },
  { i: "0472", n: "전예림", de: "신경외과", s: [] },
  {
    i: "0473",
    n: "정상준",
    de: "소아신경외과",
    s: ["소아 뇌종양", "모야모야병"],
  },
  {
    i: "0474",
    n: "조영현",
    de: "신경외과",
    s: ["뇌종양(뇌수막종", "신경초종"],
  },
  { i: "0475", n: "최준호", de: "신경외과", s: ["성인모야모야병", "뇌동맥류"] },
  {
    i: "0476",
    n: "홍석호",
    de: "신경외과",
    s: ["손떨림 초음파수술", "안면경련"],
  },
  { i: "0477", n: "홍창기", de: "신경외과", s: ["뇌종양", "두개저종양"] },
  { i: "0478", n: "권유현", de: "신경외과", s: [] },
  { i: "0479", n: "김경주", de: "신경외과", s: [] },
  { i: "0480", n: "김민한", de: "신경외과", s: [] },
  { i: "0481", n: "은찬보", de: "신경외과", s: [] },
  { i: "0482", n: "이량훈", de: "신경외과", s: [] },
  { i: "0483", n: "정서미", de: "신경외과", s: [] },
  { i: "0484", n: "정현철", de: "신경외과", s: [] },
  { i: "0485", n: "허윤희", de: "신경외과", s: [] },
  {
    i: "0486",
    n: "김효상",
    de: "신장내과",
    s: ["신장 질환", "신장이식 클리닉"],
  },
  {
    i: "0487",
    n: "백충희",
    de: "신장내과",
    s: ["신장이식 클리닉", "신장질환"],
  },
  { i: "0488", n: "양원석", de: "신장내과", s: ["신장 질환"] },
  {
    i: "0489",
    n: "장재원",
    de: "신장내과",
    s: ["당뇨신장병증 클리닉", "신장 질환"],
  },
  { i: "0490", n: "정찬영", de: "신장내과", s: ["신장질환", "신장이식클리닉"] },
  { i: "0491", n: "허가영", de: "신장내과", s: ["신장질환", "신장이식클리닉"] },
  { i: "0492", n: "김윤용", de: "신장내과", s: ["신장질환"] },
  { i: "0493", n: "오유진", de: "신장내과", s: [] },
  { i: "0494", n: "임지윤", de: "신장내과", s: ["신장질환"] },
  { i: "0495", n: "전혜원", de: "신장내과", s: [] },
  { i: "0496", n: "정은지", de: "신장내과", s: [] },
  { i: "0497", n: "최유진", de: "신장내과", s: ["신장질환"] },
  { i: "0498", n: "강덕현", de: "심장내과", s: ["승모판질환", "심내막염"] },
  {
    i: "0499",
    n: "강도윤",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  {
    i: "0500",
    n: "강수진",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  { i: "0501", n: "김가윤", de: "심장내과", s: ["심장판막질환", "심장초음파"] },
  { i: "0502", n: "김대희", de: "심장내과", s: ["판막질환", "심장초음파"] },
  { i: "0503", n: "김동현", de: "심장내과", s: ["부정맥질환"] },
  { i: "0504", n: "김민석", de: "심장내과", s: ["심부전", "심인성 쇼크"] },
  { i: "0505", n: "김성환", de: "심장내과", s: ["부정맥"] },
  { i: "0506", n: "김아람", de: "심장내과", s: ["심부전", "심인성쇼크"] },
  {
    i: "0507",
    n: "김영학",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  { i: "0508", n: "김재중", de: "심장내과", s: ["심부전", "심장이식클리닉"] },
  {
    i: "0509",
    n: "김주현",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  {
    i: "0510",
    n: "김준",
    de: "심장내과",
    s: ["부정맥질환", "전극선제거술(transvenous lead extraction)"],
  },
  {
    i: "0511",
    n: "김태오",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  { i: "0512", n: "남기병", de: "심장내과", s: ["부정맥"] },
  {
    i: "0513",
    n: "박덕우",
    de: "심장내과",
    s: ["관상동맥질환(협심증ㆍ심근경색증)", "대동맥판막스텐트치료클리닉"],
  },
  {
    i: "0514",
    n: "박성욱",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  {
    i: "0515",
    n: "박승정",
    de: "심장내과",
    s: ["관상동맥질환", "협심증·심근경색증"],
  },
  { i: "0516", n: "박찬순", de: "심장내과", s: ["심장판막질환", "심장초음파"] },
  {
    i: "0517",
    n: "박한수",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  { i: "0518", n: "선병주", de: "심장내과", s: ["심장판막질환", "대동맥질환"] },
  {
    i: "0519",
    n: "송재관",
    de: "심장내과",
    s: ["대동맥판막 협착 클리닉", "비후성 심근병증"],
  },
  {
    i: "0520",
    n: "송종민",
    de: "심장내과",
    s: ["선천성클리닉(GUCH)클리닉", "심방중격결손클리닉"],
  },
  { i: "0521", n: "심인경", de: "심장내과", s: [] },
  {
    i: "0522",
    n: "안수연",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  {
    i: "0523",
    n: "안정민",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  {
    i: "0524",
    n: "위성봉",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  { i: "0525", n: "이사민", de: "심장내과", s: ["심장판막질환", "심근병증"] },
  { i: "0526", n: "이상언", de: "심장내과", s: ["심장이식클리닉", "심부전"] },
  {
    i: "0527",
    n: "이승환",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  { i: "0528", n: "이중민", de: "심장내과", s: ["부정맥질환"] },
  {
    i: "0529",
    n: "이철환",
    de: "심장내과",
    s: ["관상동맥질환(협심증", "심근경색증)"],
  },
  { i: "0530", n: "조민수", de: "심장내과", s: ["부정맥질환"] },
  { i: "0531", n: "최기준", de: "심장내과", s: ["부정맥"] },
  { i: "0532", n: "한기훈", de: "심장내과", s: ["고지혈증", "고혈압"] },
  { i: "0533", n: "현준호", de: "심장내과", s: ["심부전", "심장이식클리닉"] },
  { i: "0534", n: "김기환", de: "심장내과", s: [] },
  { i: "0535", n: "김재한", de: "심장내과", s: ["부정맥질환"] },
  { i: "0536", n: "김찬중", de: "심장내과", s: [] },
  { i: "0537", n: "박성희", de: "심장내과", s: [] },
  { i: "0538", n: "오하은", de: "심장내과", s: ["심부전"] },
  { i: "0539", n: "유재성", de: "심장내과", s: [] },
  { i: "0540", n: "위재종", de: "심장내과", s: [] },
  { i: "0541", n: "이예지", de: "심장내과", s: [] },
  { i: "0542", n: "이진수", de: "심장내과", s: [] },
  { i: "0543", n: "전진성", de: "심장내과", s: [] },
  { i: "0544", n: "정진아", de: "심장내과", s: [] },
  { i: "0545", n: "최형우", de: "심장내과", s: [] },
  { i: "0546", n: "한상영", de: "심장내과", s: [] },
  { i: "0547", n: "황우철", de: "심장내과", s: [] },
  {
    i: "0548",
    n: "이승학",
    de: "소아재활의학과",
    s: ["뇌신경재활", "말초신경손상"],
  },
  { i: "0549", n: "강필제", de: "심장혈관흉부외과", s: [] },
  {
    i: "0550",
    n: "구민정",
    de: "심장혈관흉부외과",
    s: ["성인심장질환", "대동맥질환"],
  },
  {
    i: "0551",
    n: "김기태",
    de: "심장혈관흉부외과",
    s: ["관상동맥질환", "심장이식"],
  },
  {
    i: "0552",
    n: "김준범",
    de: "심장혈관흉부외과",
    s: ["대동맥질환", "대동맥판막성형술"],
  },
  {
    i: "0553",
    n: "김호진",
    de: "심장혈관흉부외과",
    s: ["관상동맥질환", "심장판막질환"],
  },
  {
    i: "0554",
    n: "김홍래",
    de: "심장혈관흉부외과",
    s: ["대동맥질환", "심장판막질환"],
  },
  {
    i: "0555",
    n: "유재석",
    de: "심장혈관흉부외과",
    s: ["심장판막질환", "판막성형술"],
  },
  {
    i: "0556",
    n: "정성호",
    de: "심장혈관흉부외과",
    s: ["성인심장질환", "심장이식"],
  },
  {
    i: "0557",
    n: "정철현",
    de: "심장혈관흉부외과",
    s: ["관상동맥질환", "심장판막질환 및 기타성인심장질환"],
  },
  { i: "0558", n: "권보상", de: "소아심장외과", s: [] },
  {
    i: "0559",
    n: "김동희",
    de: "소아심장외과",
    s: ["선천성 심장병", "소아 심장외과 질환"],
  },
  { i: "0560", n: "김시아", de: "심장혈관흉부외과", s: ["폐암", "흉선종"] },
  { i: "0561", n: "김용희", de: "심장혈관흉부외과", s: ["폐암", "식도암"] },
  { i: "0562", n: "김인하", de: "심장혈관흉부외과", s: ["폐암", "흉선종"] },
  { i: "0563", n: "김지용", de: "심장혈관흉부외과", s: ["폐암", "흉선종"] },
  { i: "0564", n: "김형렬", de: "심장혈관흉부외과", s: ["폐암", "식도암"] },
  { i: "0565", n: "박승일", de: "심장혈관흉부외과", s: ["폐암", "기관질환"] },
  {
    i: "0566",
    n: "박천수",
    de: "소아심장외과",
    s: ["선천성 심장병", "소아 심장외과 질환"],
  },
  {
    i: "0567",
    n: "송영관",
    de: "소아심장외과",
    s: ["선천성 심장병", "소아 심장외과 질환"],
  },
  { i: "0568", n: "윤재광", de: "심장혈관흉부외과", s: ["폐암", "흉선종"] },
  {
    i: "0569",
    n: "윤태진",
    de: "소아심장외과",
    s: ["선천성 심장병", "소아 심장외과 질환"],
  },
  { i: "0570", n: "이근동", de: "심장혈관흉부외과", s: ["폐암", "흉선종"] },
  { i: "0571", n: "주서희", de: "심장혈관흉부외과", s: [] },
  {
    i: "0572",
    n: "최세훈",
    de: "심장혈관흉부외과",
    s: ["폐암", "비디오흉강경수술(폐암"],
  },
  {
    i: "0573",
    n: "최은석",
    de: "소아심장외과",
    s: ["선천성 심장병", "소아 심장외과 질환"],
  },
  { i: "0574", n: "홍정애", de: "심장혈관흉부외과", s: [] },
  { i: "0575", n: "권영건", de: "심장혈관흉부외과", s: [] },
  { i: "0576", n: "김동희", de: "심장혈관흉부외과", s: [] },
  { i: "0577", n: "김사리", de: "심장혈관흉부외과", s: [] },
  { i: "0578", n: "김재훈", de: "심장혈관흉부외과", s: [] },
  { i: "0579", n: "김준영", de: "심장혈관흉부외과", s: [] },
  { i: "0580", n: "나혜림", de: "심장혈관흉부외과", s: [] },
  { i: "0581", n: "박효근", de: "심장혈관흉부외과", s: [] },
  { i: "0582", n: "유가영", de: "심장혈관흉부외과", s: [] },
  { i: "0583", n: "이요셉", de: "심장혈관흉부외과", s: [] },
  { i: "0584", n: "이준오", de: "심장혈관흉부외과", s: [] },
  {
    i: "0585",
    n: "장동희",
    de: "소아심장외과",
    s: ["선천성 심장병", "소아 심장외과 질환"],
  },
  { i: "0586", n: "정은영", de: "심장혈관흉부외과", s: [] },
  { i: "0587", n: "천상욱", de: "심장혈관흉부외과", s: [] },
  { i: "0588", n: "한동엽", de: "심장혈관흉부외과", s: [] },
  { i: "0589", n: "현승지", de: "심장혈관흉부외과", s: [] },
  {
    i: "0590",
    n: "국문석",
    de: "안과",
    s: ["백내장(단초점·다초점 렌즈 삽입)", "녹내장"],
  },
  { i: "0591", n: "김고은", de: "안과", s: ["녹내장", "백내장"] },
  {
    i: "0592",
    n: "김윤전",
    de: "안과",
    s: ["황반변성", "망막·초자체(유리체) 질환"],
  },
  {
    i: "0593",
    n: "김재용",
    de: "안과",
    s: ["백내장(단초점·다초점 렌즈 삽입)", "각막"],
  },
  { i: "0594", n: "김중곤", de: "안과", s: ["망막", "유리체"] },
  { i: "0595", n: "문예지", de: "안과", s: ["성인 사시", "시신경 질환"] },
  { i: "0596", n: "사호석", de: "안과", s: ["성형안과", "눈꺼풀질환"] },
  { i: "0597", n: "성경림", de: "안과", s: ["녹내장", "백내장"] },
  { i: "0598", n: "양민규", de: "안과", s: ["성형안과", "눈꺼풀 질환"] },
  {
    i: "0599",
    n: "양지명",
    de: "안과",
    s: ["망막·초자체(유리체) 질환", "포도막염"],
  },
  { i: "0600", n: "어규상", de: "안과", s: ["백내장", "각막"] },
  { i: "0601", n: "이병주", de: "안과", s: ["성인 사시", "시신경 질환"] },
  {
    i: "0602",
    n: "이준엽",
    de: "안과",
    s: ["망막 및 유리체 질환", "황반변성 정밀 클리닉"],
  },
  { i: "0603", n: "이훈", de: "안과", s: ["백내장", "레이저 백내장 클리닉"] },
  {
    i: "0604",
    n: "정호석",
    de: "안과",
    s: ["백내장(단초점·다초점 렌즈 삽입)", "각막"],
  },
  { i: "0605", n: "한예은", de: "안과", s: ["당뇨망막클리닉", "망막"] },
  {
    i: "0606",
    n: "김성호",
    de: "안과",
    s: ["당뇨망막클리닉", "망막·초자체(유리체) 질환"],
  },
  { i: "0607", n: "김태연", de: "안과", s: ["백내장", "각막"] },
  { i: "0608", n: "나용진", de: "안과", s: ["녹내장", "백내장 안과질환"] },
  { i: "0609", n: "송명선", de: "안과", s: ["백내장", "각막"] },
  {
    i: "0610",
    n: "채우정",
    de: "안과",
    s: ["당뇨망막클리닉", "망막·초자체(유리체) 질환"],
  },
  { i: "0611", n: "권혁수", de: "알레르기내과", s: ["천식", "비염"] },
  { i: "0612", n: "김태범", de: "알레르기내과", s: ["천식", "비염"] },
  { i: "0613", n: "송우정", de: "알레르기내과", s: ["만성기침", "난치성기침"] },
  { i: "0614", n: "조유숙", de: "알레르기내과", s: ["천식", "비염"] },
  { i: "0615", n: "서민교", de: "알레르기내과", s: ["알레르기질환", "천식"] },
  { i: "0616", n: "강준원", de: "영상의학과", s: ["영상의학과"] },
  {
    i: "0617",
    n: "고기영",
    de: "영상의학과",
    s: ["혈관·비혈관계 중재적시술(뇌두경부 제외)"],
  },
  { i: "0618", n: "고흥규", de: "영상의학과", s: ["간암", "혈관질환 치료"] },
  {
    i: "0619",
    n: "구현우",
    de: "영상의학과",
    s: ["소아청소년 영상의학과", "소아심장 영상(CT"],
  },
  { i: "0620", n: "구현정", de: "영상의학과", s: ["영상의학과"] },
  {
    i: "0621",
    n: "권동일",
    de: "영상의학과",
    s: ["혈관·비혈관계 인터벤션 시술(뇌두경부 제외)"],
  },
  {
    i: "0622",
    n: "권보성",
    de: "영상의학과",
    s: ["신경중재의학 (뇌혈관질환의 진단과 치료", "뇌동맥류 색전술"],
  },
  {
    i: "0623",
    n: "김건하",
    de: "영상의학과",
    s: ["인터벤션영상의학(혈관·비혈관계 인터벤션시술(뇌두경부 제외)"],
  },
  { i: "0624", n: "김경원", de: "영상의학과", s: ["영상의학과"] },
  {
    i: "0625",
    n: "김남국",
    de: "영상의학과",
    s: ["의료영상 매개연구", "의료영상 매개연구"],
  },
  { i: "0626", n: "김동욱", de: "영상의학과", s: [] },
  { i: "0627", n: "김동환", de: "영상의학과", s: [] },
  { i: "0628", n: "김미영", de: "영상의학과", s: [] },
  { i: "0629", n: "김민정", de: "영상의학과", s: [] },
  { i: "0630", n: "김소연", de: "영상의학과", s: [] },
  {
    i: "0631",
    n: "김아영",
    de: "영상의학과",
    s: ["복부 영상의학", "위장관 영상(CT"],
  },
  { i: "0632", n: "김미현", de: "영상의학과", s: [] },
  { i: "0633", n: "김승훈", de: "영상의학과", s: ["영상의학과"] },
  { i: "0634", n: "김은영", de: "영상의학과", s: [] },
  {
    i: "0635",
    n: "김지훈",
    de: "영상의학과",
    s: ["혈관계 인터벤션", "당뇨발"],
  },
  { i: "0636", n: "김정곤", de: "영상의학과", s: ["영상의학과"] },
  { i: "0637", n: "김정임", de: "영상의학과", s: [] },
  { i: "0638", n: "김진형", de: "영상의학과", s: ["비루관협착", "식도"] },
  {
    i: "0639",
    n: "김진희",
    de: "영상의학과",
    s: ["영상의학과", "복부영상의학"],
  },
  { i: "0640", n: "김평화", de: "영상의학과", s: [] },
  { i: "0641", n: "김학희", de: "영상의학과", s: ["유방암 조기진단클리닉"] },
  { i: "0642", n: "김현지", de: "영상의학과", s: [] },
  { i: "0643", n: "김현진", de: "영상의학과", s: ["영상의학과"] },
  { i: "0644", n: "김형중", de: "영상의학과", s: [] },
  { i: "0645", n: "김혜영", de: "영상의학과", s: [] },
  {
    i: "0646",
    n: "김호성",
    de: "영상의학과",
    s: ["신경두경부 영상의학", "뇌종양영상"],
  },
  { i: "0647", n: "김희정", de: "영상의학과", s: [] },
  { i: "0648", n: "노윤화", de: "영상의학과", s: [] },
  { i: "0649", n: "도경현", de: "영상의학과", s: [] },
  { i: "0650", n: "박계진", de: "영상의학과", s: [] },
  { i: "0651", n: "박로희", de: "영상의학과", s: [] },
  { i: "0652", n: "박미연", de: "영상의학과", s: [] },
  { i: "0653", n: "박상익", de: "영상의학과", s: [] },
  { i: "0654", n: "박선영", de: "영상의학과", s: [] },
  { i: "0655", n: "박성빈", de: "영상의학과", s: ["비뇨생식영상의학"] },
  { i: "0656", n: "박성호", de: "영상의학과", s: ["영상의학과"] },
  { i: "0657", n: "박소현", de: "영상의학과", s: [] },
  { i: "0658", n: "박소희", de: "영상의학과", s: [] },
  { i: "0659", n: "박예원", de: "영상의학과", s: [] },
  { i: "0660", n: "박효정", de: "영상의학과", s: [] },
  {
    i: "0661",
    n: "백정환",
    de: "영상의학과",
    s: ["갑상선 및 두경부 중재적 클리닉(고주파치료)"],
  },
  { i: "0662", n: "백태욱", de: "영상의학과", s: [] },
  { i: "0663", n: "변재호", de: "소화기병센터", s: [] },
  { i: "0664", n: "서민국", de: "영상의학과", s: [] },
  {
    i: "0665",
    n: "서종현",
    de: "영상의학과",
    s: ["신경두경부 영상의학", "아산임상시험영상의학지원실(AIM)"],
  },
  { i: "0666", n: "서준범", de: "영상의학과", s: [] },
  {
    i: "0667",
    n: "송윤선",
    de: "영상의학과",
    s: ["급성뇌졸중 혈관내 치료", "뇌동맥류 색전술"],
  },
  { i: "0668", n: "송재우", de: "영상의학과", s: [] },
  { i: "0669", n: "신용문", de: "영상의학과", s: [] },
  { i: "0670", n: "신소연", de: "영상의학과", s: [] },
  {
    i: "0671",
    n: "신지훈",
    de: "영상의학과",
    s: ["부인과 시술(난소 자궁내막종 경화술", "자궁근종 자궁동맥색전술"],
  },
  { i: "0672", n: "신희정", de: "영상의학과", s: ["유방암 조기진단클리닉"] },
  { i: "0673", n: "안유라", de: "영상의학과", s: [] },
  { i: "0674", n: "양동현", de: "영상의학과", s: [] },
  { i: "0675", n: "오상영", de: "영상의학과", s: [] },
  { i: "0676", n: "원형진", de: "영상의학과", s: [] },
  { i: "0677", n: "윤재성", de: "영상의학과", s: [] },
  {
    i: "0678",
    n: "윤현기",
    de: "영상의학과",
    s: ["혈관·비혈관계 중재적시술(뇌두경부 제외)"],
  },
  { i: "0679", n: "윤희망", de: "영상의학과", s: [] },
  { i: "0680", n: "이경진", de: "영상의학과", s: [] },
  {
    i: "0681",
    n: "이덕희",
    de: "영상의학과",
    s: ["뇌동맥류색전술", "뇌혈관협착증 중재시술"],
  },
  { i: "0682", n: "이동준", de: "영상의학과", s: [] },
  { i: "0683", n: "이민희", de: "영상의학과", s: [] },
  { i: "0684", n: "이상민", de: "영상의학과", s: [] },
  { i: "0685", n: "이상훈", de: "영상의학과", s: ["근골격계 중재적시술"] },
  { i: "0686", n: "이소정", de: "영상의학과", s: ["영상의학과"] },
  { i: "0687", n: "이승민", de: "영상의학과", s: [] },
  { i: "0688", n: "이승수", de: "영상의학과", s: [] },
  {
    i: "0689",
    n: "이정현",
    de: "영상의학과",
    s: ["두경부중재클리닉(하마종", "림프관종을 비롯한 경부낭종"],
  },
  { i: "0690", n: "이종석", de: "영상의학과", s: [] },
  { i: "0691", n: "이종은", de: "영상의학과", s: [] },
  { i: "0692", n: "이진성", de: "영상의학과", s: [] },
  { i: "0693", n: "이충욱", de: "영상의학과", s: ["영상의학과"] },
  { i: "0694", n: "이한나", de: "영상의학과", s: [] },
  { i: "0695", n: "임병수", de: "영상의학과", s: ["인터벤션 의학 분야"] },
  { i: "0696", n: "장종건", de: "영상의학과", s: [] },
  {
    i: "0697",
    n: "정새롬",
    de: "영상의학과",
    s: [
      "신경두경부영상의학(갑상선 및 두경부 조직검사/ 중재시술 클리닉(에탄올/고주파치료)",
    ],
  },
  { i: "0698", n: "장현지", de: "영상의학과", s: [] },
  { i: "0699", n: "장혜영", de: "영상의학과", s: [] },
  { i: "0700", n: "전지영", de: "영상의학과", s: [] },
  { i: "0701", n: "정승채", de: "영상의학과", s: [] },
  { i: "0702", n: "정아영", de: "영상의학과", s: [] },
  { i: "0703", n: "정혜원", de: "영상의학과", s: ["영상의학과"] },
  {
    i: "0704",
    n: "조영아",
    de: "영상의학과",
    s: ["소아청소년 영상의학과", "소아심장 영상(CT"],
  },
  { i: "0705", n: "차주희", de: "영상의학과", s: ["영상의학과"] },
  {
    i: "0706",
    n: "채은영",
    de: "영상의학과",
    s: ["유방영상의학(유방중재시술)"],
  },
  { i: "0707", n: "채은진", de: "영상의학과", s: [] },
  { i: "0708", n: "최상현", de: "영상의학과", s: [] },
  { i: "0709", n: "최세진", de: "영상의학과", s: [] },
  { i: "0710", n: "최양신", de: "영상의학과", s: [] },
  {
    i: "0711",
    n: "최영준",
    de: "영상의학과",
    s: ["갑상선 및 두경부중재적클리닉(고주파치료)"],
  },
  { i: "0712", n: "최우정", de: "영상의학과", s: [] },
  { i: "0713", n: "최주애", de: "영상의학과", s: [] },
  {
    i: "0714",
    n: "최충곤",
    de: "영상의학과",
    s: ["뇌신경계 영상진단 및 시술"],
  },
  { i: "0715", n: "추희호", de: "영상의학과", s: [] },
  { i: "0716", n: "팽미혜", de: "영상의학과", s: [] },
  { i: "0717", n: "허수빈", de: "영상의학과", s: [] },
  { i: "0718", n: "홍길선", de: "영상의학과", s: [] },
  { i: "0719", n: "황지선", de: "영상의학과", s: [] },
  { i: "0720", n: "김건엽", de: "영상의학과", s: [] },
  { i: "0721", n: "김신영", de: "영상의학과", s: [] },
  { i: "0722", n: "문자영", de: "영상의학과", s: [] },
  { i: "0723", n: "박소연", de: "영상의학과", s: [] },
  { i: "0724", n: "서거정", de: "영상의학과", s: [] },
  { i: "0725", n: "안혜민", de: "영상의학과", s: [] },
  { i: "0726", n: "정용준", de: "영상의학과", s: [] },
  { i: "0727", n: "최현의", de: "영상의학과", s: [] },
  { i: "0728", n: "김지유", de: "외과", s: [] },
  { i: "0729", n: "송경미", de: "외과", s: [] },
  { i: "0730", n: "고창석", de: "위장관외과", s: ["위암", "로봇수술"] },
  {
    i: "0731",
    n: "공충식",
    de: "위장관외과",
    s: ["위암", "위·식도역류질환수술"],
  },
  {
    i: "0732",
    n: "김범수",
    de: "위장관외과",
    s: ["위암", "기질성종양(기스트)"],
  },
  {
    i: "0733",
    n: "민사홍",
    de: "위장관외과",
    s: ["위암", "위식도역류질환수술"],
  },
  { i: "0734", n: "오슬기", de: "위장관외과", s: [] },
  { i: "0735", n: "오정아", de: "위장관외과", s: [] },
  {
    i: "0736",
    n: "유문원",
    de: "위장관외과",
    s: ["위암", "위·식도역류질환수술"],
  },
  {
    i: "0737",
    n: "육정환",
    de: "위장관외과",
    s: ["위암", "위장관외과질환수술(개복수술)"],
  },
  { i: "0738", n: "이인섭", de: "위장관외과", s: ["위암", "복강경/로봇수술"] },
  { i: "0739", n: "정성아", de: "위장관외과", s: ["위암", "로봇수술"] },
  { i: "0740", n: "조진원", de: "위장관외과", s: [] },
  { i: "0741", n: "유주노", de: "위장관외과", s: [] },
  { i: "0742", n: "정병문", de: "위장관외과", s: [] },
  { i: "0743", n: "고범석", de: "유방외과", s: ["수술후퇴원클리닉", "유방암"] },
  { i: "0744", n: "김지민", de: "유방외과", s: [] },
  { i: "0745", n: "김지선", de: "유방외과", s: ["유방암클리닉", "유방질환"] },
  { i: "0746", n: "김희정", de: "유방외과", s: ["수술후퇴원클리닉", "유방암"] },
  { i: "0747", n: "서도담", de: "유방외과", s: [] },
  {
    i: "0748",
    n: "손병호",
    de: "유방외과",
    s: ["유방암", "미용적 유방암수술"],
  },
  { i: "0749", n: "유태경", de: "유방외과", s: ["유방암클리닉", "로봇수술"] },
  {
    i: "0750",
    n: "이새별",
    de: "유방외과",
    s: ["수술후퇴원클리닉", "유방암클리닉(유방암"],
  },
  { i: "0751", n: "신영일", de: "유방외과", s: [] },
  {
    i: "0752",
    n: "이영진",
    de: "유방외과",
    s: ["양성신환초진클리닉", "유방암클리닉"],
  },
  { i: "0753", n: "이유라", de: "유방외과", s: ["유방질환"] },
  { i: "0754", n: "이종원", de: "유방외과", s: ["수술후퇴원클리닉", "유방암"] },
  { i: "0755", n: "정문용", de: "유방외과", s: [] },
  { i: "0756", n: "정일용", de: "유방외과", s: ["유방암", "유방암 수술"] },
  { i: "0757", n: "주요한", de: "유방외과", s: [] },
  { i: "0758", n: "김이진", de: "유방외과", s: [] },
  { i: "0759", n: "류호현", de: "유방외과", s: [] },
  { i: "0760", n: "오도연", de: "유방외과", s: [] },
  { i: "0761", n: "이중권", de: "유방외과", s: [] },
  { i: "0762", n: "이충만", de: "유방외과", s: [] },
  { i: "0763", n: "권효정", de: "응급의학과", s: ["중환자의학", "소생의학"] },
  { i: "0764", n: "김동주", de: "응급의학과", s: ["중환자의학", "소생의학"] },
  { i: "0765", n: "김상민", de: "응급의학과", s: ["중환자의학", "소생의학"] },
  { i: "0766", n: "김원영", de: "응급의학과", s: ["중환자의학", "소생의학"] },
  { i: "0767", n: "김윤정", de: "응급의학과", s: ["중환자의학", "소생의학"] },
  { i: "0768", n: "김준성", de: "응급의학과", s: ["응급의학", "소생의학"] },
  { i: "0769", n: "박한나", de: "응급의학과", s: ["중환자의학", "소생의학"] },
  {
    i: "0770",
    n: "서동우",
    de: "응급의학과",
    s: ["응급의학과", "응급 심장전문 처치술"],
  },
  { i: "0771", n: "손창환", de: "응급의학과", s: ["응급의학", "임상독성학"] },
  { i: "0772", n: "안신", de: "응급의학과", s: ["응급의학", "종양혈액응급"] },
  {
    i: "0773",
    n: "유승목",
    de: "응급의학과",
    s: ["응급의학과", "응급중환자실"],
  },
  { i: "0774", n: "이윤선", de: "응급의학과", s: ["내과응급", "암응급"] },
  { i: "0775", n: "이재호", de: "응급의학과", s: ["응급의학", "환자안전"] },
  { i: "0776", n: "정성민", de: "응급의학과", s: ["중환자의학", "소생의학"] },
  { i: "0777", n: "채보라", de: "응급의학과", s: ["중환자의학", "재난의학"] },
  { i: "0778", n: "홍석인", de: "응급의학과", s: ["응급의학", "소생의학"] },
  { i: "0779", n: "하승원", de: "응급의학과", s: ["응급의학", "소생의학"] },
  { i: "0780", n: "한지우", de: "응급의학과", s: ["응급의학", "소생의학"] },
  { i: "0781", n: "이종승", de: "응급의학과", s: [] },
  { i: "0782", n: "강영지", de: "이비인후과", s: [] },
  {
    i: "0783",
    n: "강우석",
    de: "이비인후과",
    s: ["인공와우이식", "돌발성 난청"],
  },
  { i: "0784", n: "권민수", de: "이비인후과", s: ["두경부암", "침샘종양"] },
  { i: "0785", n: "김지희", de: "이비인후과", s: ["만성부비동염", "코종양"] },
  { i: "0786", n: "박홍주", de: "이비인후과", s: ["인공와우이식", "난청"] },
  { i: "0787", n: "안중호", de: "이비인후과", s: ["난청", "보청기"] },
  { i: "0788", n: "유명상", de: "이비인후과", s: ["종양(코", "부비동"] },
  { i: "0789", n: "이윤세", de: "이비인후과", s: ["갑상선암", "두경부암"] },
  { i: "0790", n: "장용주", de: "이비인후과", s: ["코성형"] },
  {
    i: "0791",
    n: "정영호",
    de: "이비인후과",
    s: ["갑상선암(로봇수술)", "두경부암(로봇수술)"],
  },
  { i: "0792", n: "정유삼", de: "이비인후과", s: ["코종양", "소아편도"] },
  { i: "0793", n: "정종우", de: "이비인후과", s: ["중이염", "난청"] },
  { i: "0794", n: "최승호", de: "이비인후과", s: ["갑상선암", "구강암"] },
  { i: "0795", n: "한승훈", de: "이비인후과", s: ["구강", "인후두"] },
  { i: "0796", n: "정인성", de: "이비인후과", s: ["비과학(코질환)"] },
  { i: "0797", n: "김태원", de: "종양내과", s: ["대장암", "직장암"] },
  {
    i: "0798",
    n: "배균섭",
    de: "임상약리학과",
    s: ["신약개발전략", "임상시험"],
  },
  {
    i: "0799",
    n: "임형석",
    de: "임상약리학과",
    s: ["신약개발전략", "임상시험"],
  },
  {
    i: "0800",
    n: "고은재",
    de: "소아재활의학과",
    s: ["소아 재활", "부인암재활"],
  },
  {
    i: "0801",
    n: "김대열",
    de: "재활의학과",
    s: ["말초신경 및 근육재활", "근전도"],
  },
  {
    i: "0802",
    n: "김원",
    de: "재활의학과",
    s: ["근골격계 질환", "목/허리통증"],
  },
  { i: "0803", n: "유종윤", de: "재활의학과", s: ["척수재활", "통증"] },
  {
    i: "0804",
    n: "전민호",
    de: "재활의학과",
    s: ["뇌신경재활(뇌졸중", "파킨슨"],
  },
  { i: "0805", n: "전재용", de: "재활의학과", s: ["암재활(통증)", "림프부종"] },
  { i: "0806", n: "차승우", de: "재활의학과", s: ["뇌신경재활", "삼킴장애"] },
  { i: "0807", n: "최경효", de: "재활의학과", s: ["통증", "근골격재활"] },
  {
    i: "0808",
    n: "손우철",
    de: "소아재활의학과",
    s: ["소아 재활의학과 질환", "근골격"],
  },
  { i: "0809", n: "이건상", de: "재활의학과", s: ["근골격", "요통"] },
  {
    i: "0810",
    n: "한소라",
    de: "재활의학과",
    s: ["재활의학과질환", "암환자재활"],
  },
  {
    i: "0811",
    n: "김효원",
    de: "소아정신건강의학과",
    s: ["발달장애", "주의력결핍과잉행동장애"],
  },
  { i: "0812", n: "박형근", de: "정신건강의학과", s: ["기분장애", "자살행동"] },
  { i: "0813", n: "신다운", de: "정신건강의학과", s: ["기분장애", "불안장애"] },
  {
    i: "0814",
    n: "신용욱",
    de: "정신건강의학과",
    s: ["불안장애", "신체형장애"],
  },
  { i: "0815", n: "이중선", de: "정신건강의학과", s: ["망상", "분열정동장애"] },
  {
    i: "0816",
    n: "이태엽",
    de: "소아정신건강의학과",
    s: ["주의력결핍과잉행동장애(ADHD)", "틱장애"],
  },
  {
    i: "0817",
    n: "정석훈",
    de: "정신건강의학과",
    s: ["불면증 및 수면장애클리닉", "암스트레스"],
  },
  {
    i: "0818",
    n: "조영탁",
    de: "정신건강의학과",
    s: ["노인정신장애", "치매클리닉"],
  },
  {
    i: "0819",
    n: "주성우",
    de: "정신건강의학과",
    s: ["조현병", "양극성 장애(조울증)"],
  },
  {
    i: "0820",
    n: "주연호",
    de: "정신건강의학과",
    s: ["조증", "조현병(정신분열증)"],
  },
  { i: "0821", n: "박동휘", de: "소아정신건강의학과", s: ["소아 정신 질환"] },
  {
    i: "0822",
    n: "배진욱",
    de: "정신건강의학과",
    s: ["기분장애", "인지행동치료"],
  },
  { i: "0823", n: "고경환", de: "정형외과", s: ["어깨 & 팔꿈치 질환", "외상"] },
  { i: "0824", n: "김완림", de: "정형외과", s: ["육종", "근골격계 종양"] },
  {
    i: "0825",
    n: "김종민",
    de: "정형외과",
    s: ["무릎관절(인공관절", "관절경 수술)"],
  },
  { i: "0826", n: "김지완", de: "정형외과", s: ["고관절", "인공관절"] },
  {
    i: "0827",
    n: "김철호",
    de: "정형외과",
    s: ["고관절 질환(인공관절치환술", "비구절골술)및 골절"],
  },
  { i: "0828", n: "박세한", de: "정형외과", s: ["척추질환(경추", "흉추"] },
  {
    i: "0829",
    n: "송주호",
    de: "정형외과",
    s: ["무릎질환(인공관절", "절골술"],
  },
  { i: "0830", n: "양은규", de: "정형외과", s: ["육종", "근골격계 종양"] },
  { i: "0831", n: "이동호", de: "정형외과", s: ["목디스크", "목척추질환"] },
  {
    i: "0832",
    n: "이범식",
    de: "정형외과",
    s: ["무릎질환(인공관절", "절골술"],
  },
  { i: "0833", n: "이종석", de: "정형외과", s: ["근골격계종양", "육종"] },
  {
    i: "0834",
    n: "이호승",
    de: "정형외과",
    s: ["족부클리닉(족관절질환", "족부기형"],
  },
  {
    i: "0835",
    n: "전인호",
    de: "정형외과",
    s: ["견관절 일반질환", "견주관절 중증 질환(어깨"],
  },
  { i: "0836", n: "조성탄", de: "정형외과", s: ["척추질환(경추", "흉추"] },
  {
    i: "0837",
    n: "조재환",
    de: "정형외과",
    s: ["요추퇴행성질환", "성인척추변형"],
  },
  {
    i: "0838",
    n: "최영락",
    de: "정형외과",
    s: ["족부클리닉(족관절질환", "족부기형"],
  },
  {
    i: "0839",
    n: "황창주",
    de: "정형외과",
    s: ["요추질환", "척추변형(측만증"],
  },
  { i: "0840", n: "김태형", de: "정형외과", s: ["정형외과질환(무릎)"] },
  { i: "0841", n: "방승민", de: "정형외과", s: ["정형외과질환(어깨)"] },
  {
    i: "0842",
    n: "이원선",
    de: "정형외과",
    s: ["수부 및 손목관절 질환", "외상 및 골절"],
  },
  { i: "0843", n: "한승수", de: "정형외과", s: ["정형외과질환(족부)"] },
  { i: "0844", n: "김규표", de: "종양내과", s: ["담도암", "췌장암"] },
  { i: "0845", n: "김선영", de: "종양내과", s: ["대장암", "직장암"] },
  { i: "0846", n: "김성배", de: "종양내과", s: ["유방암", "두경부암"] },
  { i: "0847", n: "김정은", de: "종양내과", s: ["대장암", "직장암"] },
  { i: "0848", n: "김형돈", de: "종양내과", s: ["위암", "간암"] },
  { i: "0849", n: "류민희", de: "종양내과", s: ["위암", "간암"] },
  { i: "0850", n: "류백렬", de: "종양내과", s: ["간암", "담도암"] },
  { i: "0851", n: "박숙련", de: "종양내과", s: ["위암", "간암"] },
  {
    i: "0852",
    n: "박인근",
    de: "종양내과",
    s: ["비뇨기암(전립선암", "신장암"],
  },
  { i: "0853", n: "서세영", de: "종양내과", s: ["두경부암"] },
  { i: "0854", n: "안진희", de: "종양내과", s: ["유방암", "골연부조직육종"] },
  { i: "0855", n: "유창훈", de: "종양내과", s: ["간암", "담도암"] },
  { i: "0856", n: "윤덕현", de: "종양내과", s: ["림프종", "다발골수종"] },
  { i: "0857", n: "윤신교", de: "종양내과", s: ["폐암", "흉선종양"] },
  { i: "0858", n: "이대호", de: "종양내과", s: ["폐암", "흉선종양"] },
  {
    i: "0859",
    n: "이재련",
    de: "종양내과",
    s: ["비뇨기암", "전이성비뇨기종양"],
  },
  { i: "0860", n: "이재철", de: "종양내과", s: ["폐암", "흉선종양"] },
  { i: "0861", n: "장흥문", de: "종양내과", s: ["췌장암", "담도암"] },
  { i: "0862", n: "정경해", de: "종양내과", s: ["유방암", "부인암"] },
  { i: "0863", n: "정재호", de: "종양내과", s: ["유방암"] },
  { i: "0864", n: "정혜현", de: "종양내과", s: ["유방암", "췌담도암"] },
  { i: "0865", n: "조형우", de: "종양내과", s: ["림프종", "다발골수종"] },
  { i: "0866", n: "최창민", de: "호흡기내과", s: ["폐암", "치료내시경"] },
  { i: "0867", n: "형재원", de: "종양내과", s: ["위암", "GIST"] },
  { i: "0868", n: "홍용상", de: "종양내과", s: ["대장암", "직장암"] },
  { i: "0869", n: "김성은", de: "종양내과", s: ["폐암", "흉선종양"] },
  { i: "0870", n: "김소연", de: "종양내과", s: ["위암", "GIST"] },
  { i: "0871", n: "문병선", de: "암병원", s: [] },
  { i: "0872", n: "방영학", de: "종양내과", s: [] },
  { i: "0873", n: "강동우", de: "중환자ㆍ외상외과", s: [] },
  { i: "0874", n: "권혁재", de: "중환자ㆍ외상외과", s: [] },
  { i: "0875", n: "기영준", de: "중환자ㆍ외상외과", s: [] },
  { i: "0876", n: "김보미", de: "중환자ㆍ외상외과", s: [] },
  { i: "0877", n: "백종관", de: "중환자ㆍ외상외과", s: ["외상", "중환자외과"] },
  {
    i: "0878",
    n: "장예림",
    de: "중환자ㆍ외상외과",
    s: ["중증외상", "중환자외과"],
  },
  { i: "0879", n: "최정필", de: "중환자ㆍ외상외과", s: ["외상", "중환자외과"] },
  {
    i: "0880",
    n: "홍석경",
    de: "중환자ㆍ외상외과",
    s: [
      "중환자실 치료 후 신체 장애",
      "인지장애를 경험한 환자 (외과계 환자에 한함)",
    ],
  },
  { i: "0881", n: "김민철", de: "중환자ㆍ외상외과", s: [] },
  { i: "0882", n: "이건희", de: "중환자ㆍ외상외과", s: [] },
  { i: "0883", n: "고대현", de: "진단검사의학과", s: ["수혈의학", "세포치료"] },
  {
    i: "0884",
    n: "김미나",
    de: "진단검사의학과",
    s: ["임상미생물학", "병원감염"],
  },
  {
    i: "0885",
    n: "김미영",
    de: "진단검사의학과",
    s: ["진단혈액학", "유세포분석"],
  },
  {
    i: "0886",
    n: "김솔잎",
    de: "진단검사의학과",
    s: ["임상화학", "근거중심진단검사의학"],
  },
  { i: "0887", n: "김한주", de: "진단검사의학과", s: [] },
  {
    i: "0888",
    n: "서을주",
    de: "진단검사의학과",
    s: ["세포유전학", "분자유전"],
  },
  { i: "0889", n: "성흥섭", de: "진단검사의학과", s: ["임상미생물학"] },
  { i: "0890", n: "신성환", de: "진단검사의학과", s: [] },
  {
    i: "0891",
    n: "오흥범",
    de: "진단검사의학과",
    s: ["진단면역학", "분자생물"],
  },
  { i: "0892", n: "원은정", de: "진단검사의학과", s: [] },
  {
    i: "0893",
    n: "이우창",
    de: "진단검사의학과",
    s: ["임상화학", "종양유전학"],
  },
  { i: "0894", n: "이희라", de: "진단검사의학과", s: [] },
  {
    i: "0895",
    n: "장성수",
    de: "진단검사의학과",
    s: ["진단혈액학", "혈전지혈"],
  },
  {
    i: "0896",
    n: "전사일",
    de: "진단검사의학과",
    s: ["임상화학", "약물유전학"],
  },
  {
    i: "0897",
    n: "조영욱",
    de: "진단검사의학과",
    s: ["진단혈액학", "분자진단학"],
  },
  {
    i: "0898",
    n: "추대현",
    de: "진단검사의학과",
    s: ["진단혈액학", "유세포분석"],
  },
  {
    i: "0899",
    n: "황상현",
    de: "진단검사의학과",
    s: ["진단혈액학", "진단면역"],
  },
  { i: "0900", n: "김시환", de: "진단검사의학과", s: [] },
  { i: "0901", n: "김지연", de: "진단검사의학과", s: [] },
  { i: "0902", n: "한수민", de: "진단검사의학과", s: [] },
  { i: "0903", n: "고현정", de: "치과", s: ["보존(충치", "신경치료)"] },
  { i: "0904", n: "김미리", de: "치과", s: ["보존(충치", "신경치료)"] },
  { i: "0905", n: "김수환", de: "치과", s: ["치주치료", "임플란트"] },
  { i: "0906", n: "김영성", de: "치과", s: ["치주치료", "임플란트"] },
  { i: "0907", n: "김원경", de: "치과", s: ["치주치료", "임플란트"] },
  { i: "0908", n: "김윤지", de: "치과", s: ["투명교정", "디지털교정"] },
  { i: "0909", n: "김종진", de: "치과", s: ["임플란트", "심미보철"] },
  { i: "0910", n: "백진", de: "치과", s: ["임플란트", "심미보철"] },
  { i: "0911", n: "성상진", de: "치과", s: ["치아교정", "턱교정"] },
  { i: "0912", n: "이주희", de: "치과", s: ["임플란트", "심미보철"] },
  { i: "0913", n: "차현석", de: "치과", s: ["임플란트", "심미보철"] },
  {
    i: "0914",
    n: "원종현",
    de: "피부과",
    s: ["피부암(기저세포암", "편평상피암)"],
  },
  {
    i: "0915",
    n: "이미우",
    de: "피부과",
    s: ["균상식육종 포함 림프종", "피부조직검사"],
  },
  {
    i: "0916",
    n: "이우진",
    de: "피부과",
    s: ["피부암(흑색종", "기저세포암 등)"],
  },
  { i: "0917", n: "장성은", de: "피부과", s: ["건선", "색소질환"] },
  { i: "0918", n: "정준민", de: "피부과", s: ["백반증", "류마티스 피부질환"] },
  { i: "0919", n: "최명은", de: "피부과", s: ["항노화클리닉", "아토피"] },
  {
    i: "0920",
    n: "김용일",
    de: "핵의학과",
    s: ["방사성핵종 치료", "종양핵의학"],
  },
  {
    i: "0921",
    n: "김재승",
    de: "핵의학과",
    s: ["방사성핵종 치료", "뇌신경계분자영상"],
  },
  {
    i: "0922",
    n: "류진숙",
    de: "핵의학과",
    s: ["방사성핵종 치료", "종양핵의학"],
  },
  { i: "0923", n: "문대혁", de: "핵의학과", s: ["심장핵의학", "신장핵의학"] },
  {
    i: "0924",
    n: "성창환",
    de: "핵의학과",
    s: ["뇌신경계분자영상", "종양핵의학"],
  },
  {
    i: "0925",
    n: "오민영",
    de: "핵의학과",
    s: ["뇌신경계분자영상", "소화기계핵의학"],
  },
  { i: "0926", n: "오승준", de: "핵의학과", s: ["방사화학"] },
  {
    i: "0927",
    n: "오정수",
    de: "핵의학과",
    s: ["핵의학 물리 및 영상처리", "핵의학 영상장비 정도보증"],
  },
  {
    i: "0928",
    n: "이동윤",
    de: "핵의학과",
    s: ["방사성핵종 치료", "종양핵의학"],
  },
  { i: "0929", n: "이상주", de: "핵의학과", s: ["방사화학", "방사성 의약품"] },
  {
    i: "0930",
    n: "이종진",
    de: "핵의학과",
    s: ["방사성핵종 치료", "종양핵의학"],
  },
  {
    i: "0931",
    n: "한상원",
    de: "핵의학과",
    s: ["종양핵의학", "방사성핵종치료"],
  },
  {
    i: "0932",
    n: "권준교",
    de: "혈관외과",
    s: ["복부 대동맥류", "경동맥 질환"],
  },
  {
    i: "0933",
    n: "이상아",
    de: "혈관외과",
    s: ["정맥질환", "혈액투석을 위한 동정맥루"],
  },
  {
    i: "0934",
    n: "조용필",
    de: "혈관외과",
    s: ["경동맥질환", "하지동맥(죽상)경화증"],
  },
  {
    i: "0935",
    n: "한영진",
    de: "혈관외과",
    s: ["복부 대동맥류", "말초동맥 질환"],
  },
  { i: "0936", n: "공상민", de: "혈관외과", s: [] },
  { i: "0937", n: "김성은", de: "혈관외과", s: [] },
  { i: "0938", n: "김하람", de: "혈관외과", s: [] },
  { i: "0939", n: "장혜원", de: "혈관외과", s: [] },
  { i: "0940", n: "박현경", de: "혈액내과", s: ["급성", "만성골수성백혈병"] },
  { i: "0941", n: "이정희", de: "혈액내과", s: ["골수이식", "림프구성백혈병"] },
  {
    i: "0942",
    n: "이제환",
    de: "혈액내과",
    s: ["골수이식", "골수형성이상증후군"],
  },
  { i: "0943", n: "최윤숙", de: "혈액내과", s: ["급성", "만성골수성백혈병"] },
  {
    i: "0944",
    n: "최은지",
    de: "혈액내과",
    s: ["급성·만성골수성백혈병", "골수형성이상증후군"],
  },
  { i: "0945", n: "허준영", de: "혈액내과", s: ["림프구성백혈병", "림프종"] },
  { i: "0946", n: "한진희", de: "혈액내과", s: [] },
  { i: "0947", n: "박지선", de: "혈액내과", s: [] },
  { i: "0948", n: "김민지", de: "호흡기내과", s: ["간질성폐질환", "폐암"] },
  {
    i: "0949",
    n: "김호철",
    de: "호흡기내과",
    s: ["간질성폐질환 (폐섬유증", "유육종증"],
  },
  { i: "0950", n: "박소희", de: "호흡기내과", s: [] },
  { i: "0951", n: "서우정", de: "호흡기내과", s: [] },
  {
    i: "0952",
    n: "송진우",
    de: "호흡기내과",
    s: ["간질성폐질환(폐섬유증", "유육종증"],
  },
  {
    i: "0953",
    n: "심태선",
    de: "호흡기내과",
    s: ["폐결핵", "비결핵항산균폐질환"],
  },
  { i: "0954", n: "안지환", de: "호흡기내과", s: ["호흡기질환"] },
  {
    i: "0955",
    n: "오연목",
    de: "호흡기내과",
    s: ["천식", "만성폐쇄성 폐질환"],
  },
  {
    i: "0956",
    n: "이세원",
    de: "호흡기내과",
    s: ["COPD(만성폐쇄성폐질환)", "천식"],
  },
  {
    i: "0957",
    n: "이수연",
    de: "호흡기내과",
    s: ["중환자 진료", "호흡기질환"],
  },
  { i: "0958", n: "이장호", de: "호흡기내과", s: ["COPD", "천식"] },
  { i: "0959", n: "이재승", de: "호흡기내과", s: ["호흡기질환", "폐고혈압"] },
  { i: "0960", n: "임채만", de: "호흡기내과", s: ["호흡기질환", "폐렴"] },
  {
    i: "0961",
    n: "조경욱",
    de: "호흡기내과",
    s: ["결핵", "비결핵항산균 폐질환"],
  },
  {
    i: "0962",
    n: "조원경",
    de: "국제진료센터",
    s: ["국제진료센터(외국인진료)", "호흡기질환"],
  },
  { i: "0963", n: "지원준", de: "호흡기내과", s: ["호흡기질환", "폐암"] },
  { i: "0964", n: "최명근", de: "호흡기내과", s: ["폐암", "치료 내시경"] },
  { i: "0965", n: "한수진", de: "호흡기내과", s: [] },
  { i: "0966", n: "허진원", de: "호흡기내과", s: ["중환자 치료"] },
  { i: "0967", n: "현동곤", de: "호흡기내과", s: ["호흡기내과"] },
  { i: "0968", n: "홍상범", de: "호흡기내과", s: ["호흡기질환", "중환자치료"] },
  { i: "0969", n: "박익현", de: "호흡기내과", s: [] },
  { i: "0970", n: "박준석", de: "호흡기내과", s: [] },
  { i: "0971", n: "배수현", de: "호흡기내과", s: [] },
  { i: "0972", n: "이연주", de: "호흡기내과", s: [] },
  { i: "0973", n: "정경진", de: "호흡기내과", s: [] },
  { i: "0974", n: "정정희", de: "호흡기내과", s: ["호흡기질환"] },
  { i: "0975", n: "채진아", de: "호흡기내과", s: ["호흡기질환"] },
  { i: "0976", n: "허미현", de: "호흡기내과", s: [] },
  {
    i: "0977",
    n: "강성한",
    de: "소아청소년종양혈액과",
    s: ["소아 혈액종양", "골수이식"],
  },
  {
    i: "0978",
    n: "고경남",
    de: "소아청소년종양혈액과",
    s: ["소아 혈액종양", "골수이식"],
  },
  {
    i: "0979",
    n: "김혜리",
    de: "소아청소년종양혈액과",
    s: ["소아청소년 급성림프구성 백혈병 (B세포", "T세포)"],
  },
  {
    i: "0980",
    n: "염미선",
    de: "소아신경과",
    s: ["소아 신경학", "소아 뇌전증"],
  },
  { i: "0981", n: "이진아", de: "소아감염과", s: ["소아 감염", "발열"] },
  {
    i: "0982",
    n: "임호준",
    de: "소아청소년종양혈액과",
    s: ["소아 혈액 종양", "재생불량성빈혈"],
  },
  { i: "0983", n: "장원경", de: "소아중환자과", s: ["소아중증질환"] },
  {
    i: "0984",
    n: "이범희",
    de: "의학유전학센터",
    s: ["염색체 이상", "발달지연"],
  },
  { i: "0985", n: "김다현", de: "소아전문응급센터", s: [] },
  {
    i: "0986",
    n: "김미진",
    de: "소아청소년심장과",
    s: ["소아 심장 질환", "선천성 심장병"],
  },
  { i: "0987", n: "김민정", de: "소아신경과", s: [] },
  {
    i: "0988",
    n: "김자혜",
    de: "소아내분비대사과",
    s: ["소아 내분비", "성장 클리닉"],
  },
  {
    i: "0989",
    n: "김현진",
    de: "소아신경과",
    s: ["소아 신경학", "소아 뇌전증 및 뇌전증 수술"],
  },
  {
    i: "0990",
    n: "박성종",
    de: "소아중환자과",
    s: ["소아호흡부전 및 가정용 인공호흡기 클리닉"],
  },
  {
    i: "0991",
    n: "박소원",
    de: "소아소화기영양과",
    s: ["소아 위장관 질환", "염증성 장질환 클리닉"],
  },
  { i: "0992", n: "박준성", de: "소아청소년전문과", s: [] },
  {
    i: "0993",
    n: "백재숙",
    de: "소아청소년심장과",
    s: ["소아 폐동맥", "소아 부정맥"],
  },
  { i: "0994", n: "서유리", de: "소아감염과", s: ["발열 질환", "감염 질환"] },
  {
    i: "0995",
    n: "유정진",
    de: "소아청소년심장과",
    s: ["가와사끼병", "소아 심장이식"],
  },
  {
    i: "0996",
    n: "이다경",
    de: "소아호흡기ㆍ알레르기센터",
    s: ["소아 천식", "아토피피부염"],
  },
  { i: "0997", n: "이병섭", de: "신생아과", s: ["신생아학", "미숙아 클리닉"] },
  { i: "0998", n: "이정용", de: "소아청소년전문과", s: [] },
  {
    i: "0999",
    n: "이주훈",
    de: "소아신장과",
    s: ["소아 신장학", "요로계 질환"],
  },
  { i: "1000", n: "이하나", de: "신생아과", s: [] },
  { i: "1001", n: "전민교", de: "소아전문응급센터", s: [] },
  { i: "1002", n: "정의석", de: "신생아과", s: ["신생아학", "미숙아 클리닉"] },
  {
    i: "1003",
    n: "정지원",
    de: "소아신장과",
    s: ["소아 신장 질환", "소아 류마티스 질환"],
  },
  { i: "1004", n: "정지윤", de: "신생아과", s: ["신생아학", "미숙아"] },
  { i: "1005", n: "차지혜", de: "소아전문응급센터", s: [] },
  { i: "1006", n: "최승준", de: "소아전문응급센터", s: [] },
  {
    i: "1007",
    n: "최진호",
    de: "소아내분비대사과",
    s: ["소아 내분비 질환", "성장 클리닉"],
  },
  { i: "1008", n: "한지호", de: "소아전문응급센터", s: [] },
  {
    i: "1009",
    n: "황수진",
    de: "의학유전학센터",
    s: ["선천성 대사질환", "유전질환"],
  },
  { i: "1010", n: "최연철", de: "소아청소년전문과", s: ["소아전문응급센터"] },
  { i: "1011", n: "오세호", de: "소아청소년전문과", s: [] },
  { i: "1012", n: "임수영", de: "소아전문응급센터", s: [] },
  { i: "1013", n: "김예나", de: "소아감염과", s: ["발열 질환", "감염 질환"] },
  {
    i: "1014",
    n: "박준홍",
    de: "소아내분비대사과",
    s: ["소아 내분비 질환", "의학유전학"],
  },
  {
    i: "1015",
    n: "오석희",
    de: "소아소화기영양과",
    s: ["소아 위장관 질환", "간염"],
  },
  { i: "1016", n: "장지형", de: "소아소화기영양과", s: [] },
  { i: "1017", n: "권오철", de: "소아신경과", s: [] },
  { i: "1018", n: "남윤성", de: "소아신경과", s: [] },
  {
    i: "1019",
    n: "권용재",
    de: "소아외과",
    s: ["소아외과 질환", "소아 복강경 및 로봇수술"],
  },
  { i: "1020", n: "권현희", de: "소아외과", s: ["소아 외과", "소아 신장이식"] },
  {
    i: "1021",
    n: "김대연",
    de: "소아외과",
    s: ["단장증후군 클리닉", "소아 복강경 수술"],
  },
  {
    i: "1022",
    n: "김성철",
    de: "소아외과",
    s: ["소아 외과", "소아탈장(최소피부절개)"],
  },
  {
    i: "1023",
    n: "남궁정만",
    de: "소아외과",
    s: ["소아 이식 클리닉(간·소장이식)", "소아 복강경 및 로봇수술"],
  },
  { i: "1024", n: "하수현", de: "소아외과", s: [] },
  { i: "1025", n: "금혜진", de: "소아외과", s: [] },
  { i: "1026", n: "정수민", de: "소아외과", s: [] },
  {
    i: "1027",
    n: "강승철",
    de: "소아정형외과",
    s: [
      "소아청소년 사지의 정형외과 질환 (고관절 탈구/이형성증",
      "레그-칼베-페르테스병",
    ],
  },
  {
    i: "1028",
    n: "곽윤해",
    de: "소아정형외과",
    s: ["소아/청소년 정형외과 질환(외상", "스포츠손상"],
  },
  { i: "1029", n: "박수성", de: "소아정형외과", s: ["소아 정형", "뇌성마비"] },
  { i: "1030", n: "송한솔", de: "소아중환자과", s: [] },
  { i: "1031", n: "서성원", de: "소아중환자과", s: [] },
  { i: "1032", n: "김현준", de: "소아중환자과", s: [] },
  { i: "1033", n: "박유경", de: "소아중환자과", s: [] },
  { i: "1034", n: "곽중일", de: "신생아과", s: [] },
  {
    i: "1035",
    n: "김수희",
    de: "소아호흡기ㆍ알레르기센터",
    s: ["소아 천식", "아토피피부염"],
  },
  { i: "1036", n: "김태경", de: "신생아과", s: [] },
  { i: "1037", n: "장현구", de: "소아청소년과", s: [] },
  { i: "1038", n: "조준희", de: "소아청소년과", s: [] },
  { i: "1039", n: "권혁진", de: "소아청소년심장과", s: [] },
  {
    i: "1040",
    n: "차슬기",
    de: "소아청소년심장과",
    s: ["소아 심장 질환", "선천성심장병"],
  },
  { i: "1041", n: "최성진", de: "소아청소년심장과", s: ["소아 심장 질환"] },
  { i: "1042", n: "서진경", de: "소아청소년종양혈액과", s: [] },
  {
    i: "1043",
    n: "이현헌",
    de: "소아치과",
    s: ["성장기 치과교정", "치아 맹출장애/발육장애"],
  },
  { i: "1044", n: "박소연", de: "소아치과", s: ["예방치료", "소아우식증"] },
  {
    i: "1045",
    n: "유진호",
    de: "소아호흡기ㆍ알레르기센터",
    s: ["중증 아토피피부염", "식품알레르기"],
  },
  {
    i: "1046",
    n: "윤지선",
    de: "소아호흡기ㆍ알레르기센터",
    s: ["중증 아토피피부염", "식품 알레르기"],
  },
  { i: "1047", n: "염숙경", de: "신생아과", s: ["신생아학", "미숙아"] },
  { i: "1048", n: "김채영", de: "신생아과", s: ["신생아학", "미숙아"] },
  { i: "1049", n: "김수현", de: "신생아과", s: ["신생아학", "미숙아"] },
  { i: "1050", n: "이정민", de: "신생아과", s: [] },
  { i: "1051", n: "유규상", de: "신생아과", s: [] },
  { i: "1052", n: "박주희", de: "신생아과", s: [] },
];
